import React, { useState, useEffect, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,

  PaymentMethodSelect2,
  SalesPerCustomerSelect, SalesPerCustomerTamperedSelect,
  CustomerSelect,
  DateSelect,
  ConfirmationModal,
  DetectMimeTypeFromBase64, HandleFileUpload, DownloadFile,
  PaymentStatusSelectWithAll,
  ChartOfAccountsSelect,
  DebitCreditSelect,
  CHECK_PAYMENT_METHOD,
  BankSelect,
  CheckbookSelect,
  CheckbookFromUpdateSelect,
  TaxationCodeSelect,
  CreateTableMultipleSelectMode,
  PaymentReferenceTypeModal,
  DeliveryOrderCustomerSelect,
  SalesPerCustomerMultipleSelect,
  PaymentTypeModal,
  ChartOfAccountsMultipleSelect,
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import { JournalHeader } from "../Journals/JournalHeader";
import NoAccess from "../NoAccess";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// MUI Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PostAddIcon from '@mui/icons-material/PostAdd';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const PaymentsReceived = ({active}) => {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.paymentNumber?.toLowerCase().includes(lowerValue) ||
        item.customerName1?.toLowerCase().includes(lowerValue)
    );

    setData(filtered);
  };
//#endregion









//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const [customerFilter, setCustomerFilter] = useState(null);
  const [paymentDateFilter, setPaymentDateFilter] = useState(null);
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion









//#region Variables
  const [selectedData, setSelectedData] = useState(null);

  const [customer, setCustomer] = useState(null);
  const [salesInvoicePaymentDetails, setSalesInvoicePaymentDetails] = useState([]);
  const [chartOfAccounts, setChartOfAccounts] = useState([]);
  const [paymentNumber, setPaymentNumber] = useState("xxxxxx");
  const [depositToAccount, setDepositToAccount] = useState(null);
  const [amount, setAmount] = useState(0);

  const today = new Date().toISOString().split("T")[0];
  const [paymentDate, setPaymentDate] = useState(today);

  const [paymentMethod, setPaymentMethod] = useState(null);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [notes, setNotes] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");
  const [manualInvoiceNumber, setManualInvoiceNumber] = useState("");
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [withholdingTax, setWithholdingTax] = useState(0);

  const [selectedRows, setSelectedRows] = useState([])

  //checkbook transactions
  const [bank, setBank] = useState(null);
  const [checkbook, setCheckbook] = useState(null);

  const resetVariables = () => {
    setCustomer(null);
    setSalesInvoicePaymentDetails([]);
    setChartOfAccounts([]);
    setPaymentNumber("xxxxxx");
    setDepositToAccount(null);
    setAmount(0);
    setPaymentDate(today);
    setPaymentMethod(null);
    setReferenceNumber("");
    setNotes("");
    setUploadedFile("");

    setManualInvoiceNumber("");
    setPaymentAmount(0);
    setWithholdingTax(0);

    setBank(null);
    setCheckbook(null);

    setSelectedRows([]);
    setSelectedData(null);
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/SalesInvoicePayment/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);
//#endregion








// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }

  const addHandleClick = async () => {
    setLoading(true)

    setLoading(false)
    openAddForm()
  }

  const handleAddData = async () => {
    const _chartOfAccounts = chartOfAccounts?.map((acc) => ({
      amount: acc?.debit > 0 ? acc.debit : acc?.credit ?? 0,
      debitCredit: acc?.debit > 0 ? "Debit" : "Credit",
      glAccountId: acc?.glAccountId ?? null,
    }));

    const data = {
      salesInvoicePaymentDetails: salesInvoicePaymentDetails,
      chartOfAccounts: _chartOfAccounts,
      customerId: customer?.customerId,
      paymentNumber: paymentNumber,
      depositToAccountId: depositToAccount?.id,
      amount: amount,
      paymentDate: paymentDate,
      paymentMethodId: paymentMethod?.id,
      referenceNumber: referenceNumber,
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      manualInvoiceNumber: manualInvoiceNumber,
      paymentAmount: paymentAmount,
      withholdingTax: withholdingTax,
      createdDate: new Date(),
      createdBy: accountData?.id,

      checkbookId: checkbook?.id,
      bankId: bank?.id
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/SalesInvoicePayment`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion






// #region Update function
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  
  const openUpdateForm = () => {
    setShowUpdateForm(true);
  }
  const closeUpdateForm = () => {
    setShowUpdateForm(false);
    resetVariables();
  }

  const editHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setSalesInvoicePaymentDetails(_data.salesInvoicePaymentDetails ?? []);

    const _chartOfAccounts = _data.chartOfAccounts?.map((acc) => ({
      glAccount: acc,
      glAccountId: acc?.glAccountId ?? null,
      glAccountName: acc?.glAccountName ?? "",
      glAccountNumber: acc?.glAccountNumber ?? "",
      debit: acc?.debitCredit === "Debit" ? acc?.amount ?? 0 : 0,
      credit: acc?.debitCredit === "Credit" ? acc?.amount ?? 0 : 0,
    }));

    setChartOfAccounts(_chartOfAccounts ?? []);
    setCustomer(_data.customer ?? null);
    setPaymentNumber(_data.paymentNumber ?? "");
    setDepositToAccount(_data.depositToAccount ?? null);
    setAmount(_data.amount ?? 0);
    setPaymentDate(_data.paymentDate ?? null);
    setPaymentMethod(_data.paymentMethod ?? null);
    setReferenceNumber(_data.referenceNumber ?? "");
    setNotes(_data.notes ?? "");
    setManualInvoiceNumber(_data.manualInvoiceNumber ?? "");
    setPaymentAmount(_data.paymentAmount ?? 0);
    setWithholdingTax(_data.withholdingTax ?? 0);
    setUploadedFile(_data.uploadedFile
            ? {
                base64: _data.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ),
                fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ).split("/")[1]}`
              }
            : null)

    setBank(_data.bank ?? null);
    setCheckbook(_data.checkbook ?? null);

    setLoading(false)
    openUpdateForm();
  }

  const handleUpdateData = async () => {
    const _chartOfAccounts = chartOfAccounts?.map((acc) => ({
      amount: acc?.debit > 0 ? acc.debit : acc?.credit ?? 0,
      debitCredit: acc?.debit > 0 ? "Debit" : "Credit",
      glAccountId: acc?.glAccountId ?? null,
    }));

    const data = {
      salesInvoicePaymentDetails: salesInvoicePaymentDetails,
      chartOfAccounts: _chartOfAccounts,
      customerId: customer?.customerId,
      paymentNumber: paymentNumber,
      depositToAccountId: depositToAccount?.id,
      amount: amount,
      paymentDate: paymentDate,
      paymentMethodId: paymentMethod?.id,
      referenceNumber: referenceNumber,
      notes: notes,
      uploadedFile: uploadedFile?.base64,
      updatedDate: new Date(),
      updatedBy: accountData?.id,
      manualInvoiceNumber: manualInvoiceNumber,
      paymentAmount: paymentAmount,
      withholdingTax: withholdingTax,
      checkbookId: checkbook?.id,
      bankId: bank?.id
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/SalesInvoicePayment/update/${selectedData?.id}`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 
//#endregion







// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setSalesInvoicePaymentDetails(_data.salesInvoicePaymentDetails ?? []);
    setChartOfAccounts(_data.chartOfAccounts ?? []);
    setCustomer(_data.customer ?? null);
    setPaymentNumber(_data.paymentNumber ?? "");
    setDepositToAccount(_data.depositToAccount ?? null);
    setAmount(_data.amount ?? 0);
    setPaymentDate(_data.paymentDate ?? null);
    setPaymentMethod(_data.paymentMethod ?? null);
    setReferenceNumber(_data.referenceNumber ?? "");
    setNotes(_data.notes ?? "");
    setManualInvoiceNumber(_data.manualInvoiceNumber ?? "");
    setPaymentAmount(_data.paymentAmount ?? 0);
    setWithholdingTax(_data.withholdingTax ?? 0);
    setUploadedFile(_data.uploadedFile
            ? {
                base64: _data.uploadedFile,
                contentType: DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ),
                fileName: `UploadedFile.${DetectMimeTypeFromBase64(
                  _data.uploadedFile
                ).split("/")[1]}`
              }
            : null)

    setBank(_data.bank ?? null);
    setCheckbook(_data.checkbook ?? null);

    setLoading(false)
    openViewForm();
  }
//#endregion








// #region View Sale Invoice
  const [selectedSalesInvoice, setSelectedSalesInvoice] = useState(null);
  const [showViewSalesInvoiceForm, setShowViewSalesInvoiceForm] = useState(false);
  
  const openViewSalesInvoiceForm = () => {
    setShowViewSalesInvoiceForm(true);
  }
  const closeViewSalesInvoiceForm = () => {
    setShowViewSalesInvoiceForm(false);
    setSelectedSalesInvoice(null);
    setSelectedData(null);
    setCustomer(null);
  }

  const viewSalesInvoiceHandleClick = async (data) => {
    setLoading(true);
    const _data = await fetchDataById(data);
    setSelectedSalesInvoice(_data?.salesInvoicePaymentDetails ?? []);
    setSelectedData(_data ?? null);
    setCustomer(_data?.customer ?? null);

    setLoading(false)
    openViewSalesInvoiceForm();
  }
// #endregion








// #region Chart Of Accounts
  const [selectedChartOfAccount, setSelectedChartOfAccount] = useState(null);
  const [showViewChartOfAccountForm, setShowViewChartOfAccountForm] = useState(false);
  
  const openViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(true);
  }
  const closeViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(false);
    setSelectedChartOfAccount(null);
  }

  const viewChartOfAccountHandleClick = async (data) => {
    setLoading(true);
    const _data = await fetchDataById(data);
    setSelectedChartOfAccount(_data?.chartOfAccounts ?? []);

    setLoading(false)
    openViewChartOfAccountForm();
  }
// #endregion











// #region Post function
  const [showPostForm, setShowPostForm] = useState(false);
  
  const openPostForm = () => {
    setShowPostForm(true);
  }
  const closePostForm = () => {
    setShowPostForm(false);
    resetVariables();
  }

  const postHandleClick = async (data) => {
    setLoading(true)
    const _data = await fetchDataById(data)
    setSelectedData(_data);

    setLoading(false)
    openPostForm();
  }
//#endregion










// #region Approve
  const [showStatusChangeForm, setShowStatusChangeForm] = useState(false);
  const [approvalType, setApprovalType] = useState("");
  const openStatusChangeForm = () => {
    setShowStatusChangeForm(true);
  }
  const closeStatusChangeForm = () => {
    setShowStatusChangeForm(false);
    setApprovalType("")
    setSelectedRows([])
  }

  const statusChangeApproveHandleClick = async (data) => {
    setSelectedData(data)
    setApprovalType("Approve")
    openStatusChangeForm()
  }

  const statusChangeDisapproveHandleClick = async (data) => {
    setSelectedData(data)
    setApprovalType("Disapprove")
    openStatusChangeForm()
  }

  const handleStatusChange = async () => {
    try {
      setLoading(true);

      const _data = {
        id: selectedData?.id,
        status: approvalType,
      }

      await axios.post(`${apiUrl}/api/SalesInvoicePayment/change-status-bulk`, [_data], {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to change data: ${errorMessage}`);
    } finally {
      setLoading(false)
    }
  }
//#endregion







// #region Void Invoice
  const [showVoidForm, setShowVoidForm] = useState(false);

  const openVoidForm = () => {
    setShowVoidForm(true);
  }
  const closeVoidForm = () => {
    setShowVoidForm(false);
    setSelectedData(null);
    setSelectedRows([])
  }

  const voidHandleClick = async (data) => {
    setSelectedData(data);
    openVoidForm();
  }

  const handleVoidStatus = async () => {
    try {
      setLoading(true);

      const _data = {
        id: selectedData?.id,
        status: "Void"
      }

      await axios.post(`${apiUrl}/api/SalesInvoicePayment/change-status-bulk`, [_data], {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to change data: ${errorMessage}`);
    } finally {
      setLoading(false)
    }
  }
// #endregion







//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    'PAYMENT NUMBER', 
    'CUSTOMER', 
    'SALE/S', 
    'SALES AMOUNT', 
    'ACCOUNT/S', 
    // 'DEPOSIT AMOUNT', 
    // 'PAYMENT DATE', 
    'STATUS', 
    'ACTIONS',
  ]
  const accessors = [
    'paymentNumber', 
    'customer', 
    'salesInvoicePaymentDetails', 
    'salesInvoicePaymentDetailsAmount', 
    'depositToAccount', 
    // 'depositToAccountName', 
    // 'amount', 
    // 'paymentDate', 
    'status', 
    'actions'
  ]

  const actions = [
    { 
      name: "Approve", 
      tooltip: "approve",
      icon: <ThumbUpAltIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600",
      function: statusChangeApproveHandleClick,
      visible: true,
    },
    { 
      name: "Disapprove", 
      tooltip: "disapprove",
      icon: <ThumbDownAltIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: statusChangeDisapproveHandleClick,
      visible: true,
    },
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleClick,
      visible: true,
    },
    { 
      name: "Void", 
      tooltip: "void",
      icon: <NotInterestedIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: voidHandleClick,
      visible: true,
    },
    { 
      name: "View Reference", 
      tooltip: "view",
      icon: <ListAltIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewSalesInvoiceHandleClick,
      visible: false,
    },
    { 
      name: "Post", 
      tooltip: "post",
      icon: <PostAddIcon fontSize="small" />,
      className: "bg-orange-500 hover:bg-orange-600",
      function: postHandleClick,
      visible: false,
    },
    { 
      name: "View Account", 
      tooltip: "view",
      icon: <PostAddIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewChartOfAccountHandleClick,
      visible: false,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      let url = `${apiUrl}/api/SalesInvoicePayment/customer/${customerFilter?.customerId ?? "All"}/status/${statusFilter || "All"}/paymentDate`;

      if (paymentDateFilter) {
        url += `/${paymentDateFilter}`;
      }

      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      setData(response.data);
      setFilteredData(response.data);

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [customerFilter, statusFilter, paymentDateFilter]);

  useEffect(() => {
    if(active){
      fetchData();
    }
  }, [active, fetchData])
//#endregion








//#region Change Status
  const [showChangeStatusConfirmation, setShowChangeStatusConfirmation] = useState(false)

  const openChangeStatusConfirmation = (_type) => {
    if(selectedRows.length === 0) {
      setFailMessage("Please select atleast 1 data!");
      return;
    }
    
    setShowChangeStatusConfirmation(true)
    setApprovalType(_type)
  }
  const closeChangeStatusConfirmation = () => {
    setShowChangeStatusConfirmation(false)
    setApprovalType("")
    setSelectedRows([])
  }

  const handleStatusBulkChange = async () => {
    try {
      setLoading(true);

      const _data = selectedRows?.map((item) => {
        return {
          id: item?.id,
          status: approvalType,
        }
      })

      await axios.post(`${apiUrl}/api/SalesInvoicePayment/change-status-bulk`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem updating data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to change data: ${errorMessage}`);
    } finally {
      setLoading(false)
    }
  }
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasReceivables) {
    return <NoAccess />;
  }
//#endregion


  return (
    <>
      <div className="py-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          {/* Search and Filters */}
          <div className="flex justify-between items-center gap-2 w-full">
            <div className="w-full">
              <input
                type="text"
                placeholder="Search account..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
          </div>
          <div className="flex gap-3 w-full justify-start md:justify-end">
            <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
            <button onClick={addHandleClick} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
              <AddCircleOutlineIcon fontSize="small" /> New Payment
            </button>
          </div>
        </div>

        <div className="flex gap-3 w-full justify-start py-4">
          <button onClick={()=>openChangeStatusConfirmation("Approve")} className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-600 transition shadow-md">
            <ThumbUpAltIcon fontSize="small" /> APPROVE
          </button>
          <button onClick={()=>openChangeStatusConfirmation("Disapprove")} className="flex items-center gap-2 bg-red-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-red-600 transition shadow-md">
            <ThumbUpAltIcon fontSize="small" /> DISAPPROVE
          </button>
        </div>

        <CreateTableMultipleSelectMode
          tableName={"Sales Invoice Payment"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        />
      </div>

      <AddUpdateModal
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAddData}
        modalName={"Add Payment"}

        salesInvoicePaymentHeader={selectedData}
        data={data}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        customer={customer} setCustomer={setCustomer}
        paymentNumber={paymentNumber} setPaymentNumber={setPaymentNumber}
        depositToAccount={depositToAccount} setDepositToAccount={setDepositToAccount}
        amount={amount} setAmount={setAmount}
        paymentDate={paymentDate} setPaymentDate={setPaymentDate}
        paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        bank={bank} setBank={setBank}
        checkbook={checkbook} setCheckbook={setCheckbook}

        manualInvoiceNumber={manualInvoiceNumber} setManualInvoiceNumber={setManualInvoiceNumber}
        paymentAmount={paymentAmount} setPaymentAmount={setPaymentAmount}
        withholdingTax={withholdingTax} setWithholdingTax={setWithholdingTax}

        isEditable={true}
      />
      <AddUpdateModal
        visible={showUpdateForm}
        onClose={closeUpdateForm}
        onSave={handleUpdateData}
        modalName={"Update Payment"}

        salesInvoicePaymentHeader={selectedData}
        data={data}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        customer={customer} setCustomer={setCustomer}
        paymentNumber={paymentNumber} setPaymentNumber={setPaymentNumber}
        depositToAccount={depositToAccount} setDepositToAccount={setDepositToAccount}
        amount={amount} setAmount={setAmount}
        paymentDate={paymentDate} setPaymentDate={setPaymentDate}
        paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}
        bank={bank} setBank={setBank}
        checkbook={checkbook} setCheckbook={setCheckbook}

        manualInvoiceNumber={manualInvoiceNumber} setManualInvoiceNumber={setManualInvoiceNumber}
        paymentAmount={paymentAmount} setPaymentAmount={setPaymentAmount}
        withholdingTax={withholdingTax} setWithholdingTax={setWithholdingTax}

        isEditable={true}
      />

      <ViewModal 
        visible={showViewForm}
        onClose={closeViewForm}
        // onSave={handleViewData}
        modalName={"View Payment"}

        salesInvoicePaymentHeader={selectedData}
        data={data}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer} setCustomer={setCustomer}
        paymentNumber={paymentNumber} setPaymentNumber={setPaymentNumber}
        depositToAccount={depositToAccount} setDepositToAccount={setDepositToAccount}
        amount={amount} setAmount={setAmount}
        paymentDate={paymentDate} setPaymentDate={setPaymentDate}
        paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        notes={notes} setNotes={setNotes}
        uploadedFile={uploadedFile} setUploadedFile={setUploadedFile}

        manualInvoiceNumber={manualInvoiceNumber} setManualInvoiceNumber={setManualInvoiceNumber}
        paymentAmount={paymentAmount} setPaymentAmount={setPaymentAmount}
        withholdingTax={withholdingTax} setWithholdingTax={setWithholdingTax}

        isEditable={false}
      />

      <ViewReferenceModal 
        visible={showViewSalesInvoiceForm}
        onClose={closeViewSalesInvoiceForm}
        // onSave={handleUpdateData}
        salesInvoicePaymentHeader={selectedData}
        customer={customer} setCustomer={setCustomer}
        modalName={"View Reference/s"}

        salesInvoicePaymentDetails={selectedSalesInvoice} setSalesInvoicePaymentDetails={setSelectedSalesInvoice}
      />

      <ViewChartOfAccountsModal 
        visible={showViewChartOfAccountForm}
        onClose={closeViewChartOfAccountForm}
        // onSave={handleUpdateData}
        modalName={"View Account/s"}

        chartOfAccounts={selectedChartOfAccount} setChartOfAccounts={setSelectedChartOfAccount}
      />

      <CreateJournalModal 
        visible={showPostForm}
        onClose={closePostForm}
        // onSave={handleUpdateData}
        modalName={"Create Journal"}
        isEditable={true}
        data={selectedData}
        fetchData={fetchData}
      />

      <ConfirmationModal 
        visible={showStatusChangeForm} 
        onClose={closeStatusChangeForm} 
        onSave={handleStatusChange} 
        modalName={"Approval"} 
        message={`Do you want to "${approvalType}" this invoice [ ${selectedData?.paymentNumber ?? ""} ]?.`}
      />
      
      <ConfirmationModal 
        visible={showVoidForm} 
        onClose={closeVoidForm} 
        onSave={handleVoidStatus} 
        modalName={"Void"} 
        message={`Do you want to void this [ ${selectedData?.paymentNumber || ""} ]?.`}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        customerFilter={customerFilter} setCustomerFilter={setCustomerFilter}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
        paymentDateFilter={paymentDateFilter} setPaymentDateFilter={setPaymentDateFilter}
      />

      <ConfirmationModal 
        visible={showChangeStatusConfirmation} 
        onClose={closeChangeStatusConfirmation} 
        onSave={handleStatusBulkChange} 
        modalName={`Confirmation`} 
        message={`Do you want to ${approvalType === "Approve" ? "approve" : "disapprove"} selected data?.`}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
}









//#region AddUpdate/View Modal
const AddUpdateModal = ({
  visible, onClose, onSave, modalName,
  salesInvoicePaymentHeader,
  salesInvoicePaymentDetails, setSalesInvoicePaymentDetails,
  chartOfAccounts, setChartOfAccounts,
  customer, setCustomer,
  paymentNumber, setPaymentNumber,
  depositToAccount, setDepositToAccount,
  amount, setAmount,
  paymentDate, setPaymentDate,
  paymentMethod, setPaymentMethod,
  referenceNumber, setReferenceNumber,
  notes, setNotes,
  uploadedFile, setUploadedFile,
  bank, setBank,
  checkbook, setCheckbook,

  manualInvoiceNumber, setManualInvoiceNumber,
  paymentAmount, setPaymentAmount,
  withholdingTax, setWithholdingTax,

  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSalesInvoicePaymentDetails, setShowSalesInvoicePaymentDetails] = useState(true);
  const [totalSalesInvoiceAmount, setTotalSalesInvoiceAmount] = useState(0);
  const [totalEWT, setTotalEWT] = useState(0);
  const [showChartOfAccounts, setShowChartOfAccounts] = useState(true);
  const [totalDebitChartOfAccountAmount, setTotalDebitChartOfAccountAmount] = useState(0);
  const [totalCreditChartOfAccountAmount, setTotalCreditChartOfAccountAmount] = useState(0);


//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion










//#region Bank
  const [showBankSelectForm, setShowBankSelectForm] = useState(false);
  const openBankSelectForm = () => {
    setShowBankSelectForm(true);
  }
  const closeBankSelectForm = () => {
    setShowBankSelectForm(false);
  }
//#endregion




  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!paymentNumber
      || !paymentDate
      || !paymentMethod
      || salesInvoicePaymentDetails.length <= 0
      || chartOfAccounts.length <= 0
    ) {
      setFailMessage("Please fill up all required fields. Add at least 1 sales. Add at least 1 account");
      return;
    }

    if((paymentMethod?.id === CHECK_PAYMENT_METHOD) 
    && (!bank || !referenceNumber)){
      setFailMessage("Please fill up all bank details.");
      return;
    }

    if (Number(totalDebitChartOfAccountAmount) !== Number(totalCreditChartOfAccountAmount)) {
      setFailMessage("Accounts summary is not tally.");
      return;
    }

    if (Number(totalSalesInvoiceAmount) !== Number(amount)) {
      setFailMessage("The payment amount does not match the total sales amount.");
      return;
    }

    await onSave();
    closeModal();
  };

  const closeModal = () => {
    resetLocalVariables();
    onClose();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
    setLoading(false);
    setShowSalesInvoicePaymentDetails(true);
    setTotalSalesInvoiceAmount(0);
    setTotalEWT(0);
    setSelectedSalesInvoicePaymentDetail(null)
    setCurrentPageSalesInvoicePaymentDetail(1)
    setShowAddSalesInvoicePaymentDetailForm(false)
    setShowUpdateSalesInvoicePaymentDetailForm(false)
    setShowViewSalesInvoicePaymentDetailForm(false)
    setShowDeleteSalesInvoicePaymentDetailForm(false)
    setShowChartOfAccounts(true)
    setTotalDebitChartOfAccountAmount(false)
    setTotalCreditChartOfAccountAmount(false)
  }








//#region Sales Invoice Payment Detail
  const [selectedSalesInvoicePaymentDetail, setSelectedSalesInvoicePaymentDetail] = useState(null);
  const [currentPageSalesInvoicePaymentDetail, setCurrentPageSalesInvoicePaymentDetail] = useState(1);

  const headersSalesInvoicePaymentDetail = [
    'INVOICE NUMBER', 
    'REFERENCE/S', 
    'AMOUNT DUE', 
    'VAT', 
    'EWT', 
    'AMOUNT PAID', 
    'ACTIONS'
  ]
  const accessorsSalesInvoicePaymentDetail = [
    'referenceNumber', 
    'references', 
    'amountDueBeforePayment', 
    'vat', 
    'ewt', 
    'amountPaid', 
    'actions'
  ]

  const fetchDataSalesInvoiceById = useCallback(async (_data) => {
    if(!_data?.referenceId){
      return null;
    }

    try {
      const response = await axios.get(`${apiUrl}/api/SalesInvoice/${_data?.referenceId}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  const [showAddSalesInvoicePaymentDetailForm, setShowAddSalesInvoicePaymentDetailForm] = useState(false);
  const openAddSalesInvoicePaymentDetailForm = () => {
    setShowAddSalesInvoicePaymentDetailForm(true);
  }

  const closeAddSalesInvoicePaymentDetailForm = () => {
    setShowAddSalesInvoicePaymentDetailForm(false);
    setSelectedSalesInvoicePaymentDetail(null)
  }

  const [showUpdateSalesInvoicePaymentDetailForm, setShowUpdateSalesInvoicePaymentDetailForm] = useState(false);
  const openUpdateSalesInvoicePaymentDetailForm = () => {
    setShowUpdateSalesInvoicePaymentDetailForm(true);
  }
  const closeUpdateSalesInvoicePaymentDetailForm = () => {
    setShowUpdateSalesInvoicePaymentDetailForm(false);
    setSelectedSalesInvoicePaymentDetail(null)
  }

  const editHandleSalesInvoicePaymentDetailClick = async(_data) => {
    setLoading(true)
    const _salesInvoice = await fetchDataSalesInvoiceById(_data)
    setSelectedSalesInvoicePaymentDetail(
      {
        ..._data,
        salesInvoice: _salesInvoice
      }
    )

    setLoading(false)
    openUpdateSalesInvoicePaymentDetailForm();
  }

  const [showViewSalesInvoicePaymentDetailForm, setShowViewSalesInvoicePaymentDetailForm] = useState(false);
  const openViewSalesInvoicePaymentDetailForm = () => {
    setShowViewSalesInvoicePaymentDetailForm(true);
  }
  const closeViewSalesInvoicePaymentDetailForm = () => {
    setShowViewSalesInvoicePaymentDetailForm(false);
    setSelectedSalesInvoicePaymentDetail(null)
  }

  const viewHandleSalesInvoicePaymentDetailClick = (_data) => {
    setSelectedSalesInvoicePaymentDetail(_data)
    openViewSalesInvoicePaymentDetailForm();
  }

  const [showDeleteSalesInvoicePaymentDetailForm, setShowDeleteSalesInvoicePaymentDetailForm] = useState(false);
  const openDeleteSalesInvoicePaymentDetailForm = () => {
    setShowDeleteSalesInvoicePaymentDetailForm(true);
  }
  const closeDeleteSalesInvoicePaymentDetailForm = () => {
    setShowDeleteSalesInvoicePaymentDetailForm(false);
    setSelectedSalesInvoicePaymentDetail(null)
  }

  const deleteHandleSalesInvoicePaymentDetailClick = (_data) => {
    setSelectedSalesInvoicePaymentDetail(_data)
    openDeleteSalesInvoicePaymentDetailForm();
  }

  const handleDeleteSalesInvoicePaymentDetail = () => {
    setSalesInvoicePaymentDetails(prev =>
      prev.filter(item =>
        (item.referenceNumber  !== selectedSalesInvoicePaymentDetail.referenceNumber)
      )
    );
  };

  const [showPaymentTypeModal, setShowPaymentTypeModal] = useState(false);
  const openPaymentTypeModal = () => {
    setShowPaymentTypeModal(true);
  }
  const closePaymentTypeModal = () => {
    setShowPaymentTypeModal(false);
  }

  const [preReferences, setPreReferences] = useState([]);
  const [showPreReferencesForm, setShowPreReferencesForm] = useState(false);
  const openPreReferencesForm = () => {
    setShowPreReferencesForm(true);
    closePaymentTypeModal();
  }
  const closePreReferencesForm = () => {
    setShowPreReferencesForm(false);
  }

  const addAdvancePayment = () => {
    const newDetail = {
      id: crypto.randomUUID(),
      totalAmount: 0,
      amountPaid: 0,
      amountDueBeforePayment: 0,
      reference: null,
      referenceId: null,
      referenceNumber: "",
      referenceType: "Invoice",
      taxationCodeId: null,
      taxationCode: null,
      vat: 0,
      discounts: 0,
      ewt: 0,
    };

    setSalesInvoicePaymentDetails((prev) => [...prev, newDetail]);

    closePaymentTypeModal();
  }

  useEffect(() => {
    if (preReferences.length > 0) {
      const newDetail = preReferences.map((ref) => {
        let vat = 0;

        if(ref?.vat > 0){
          vat = ((ref?.amountDue ?? 0) * 12) / 112
        }
        return ({
          id: crypto.randomUUID(),
          totalAmount: ref?.amountDue ?? 0,
          amountPaid: ref?.amountDue ?? 0,
          amountDueBeforePayment: ref?.amountDue ?? 0,
          reference: ref ?? null,
          referenceId: ref?.id ?? null,
          referenceNumber: ref?.salesInvoiceNumber ?? "",
          referenceType: "Invoice",
          taxationCodeId: null,
          taxationCode: null,
          vat: vat,
          discounts: ref?.discounts ?? 0,
          ewt: ref?.ewt ?? 0,
        })
      });

      setSalesInvoicePaymentDetails((prev) => {
        const existingIds = new Set(
          prev.map((ref) => ref.referenceId)
        );

        const uniqueDetails = newDetail.filter(
          (ref) => !existingIds.has(ref.referenceId)
        );

        return [...prev, ...uniqueDetails];
      });
      setPreReferences([])
    }
  }, [preReferences, setSalesInvoicePaymentDetails]);

  const insertData = {
    name: "Insert Payment",
    icon: <PostAddIcon fontSize="small" />,
    className: "",
    function: openPaymentTypeModal
  }

  const calculateReferenceEWT = (amountPaid, vat, taxationCode) => {
    const vatableAmount = Number(amountPaid || 0) - Number(vat || 0);
    const ewtRate = Number(taxationCode?.rate || 0) / 100;

    return vatableAmount * ewtRate;
  };

  const handleReferenceAmountChange = (id, field, value) => {
    const amount = value === "" ? "" : Number(value);

    setSalesInvoicePaymentDetails((prev) =>
      prev.map((ref) => {
        if (ref.id !== id) return ref;

        const updatedRef = {
          ...ref,
          [field]: amount,
        };

        if (field === "amountPaid") {
          updatedRef.vat =
            Number(ref?.reference?.vat ?? 0) > 0 && amount !== ""
              ? (amount * 12) / 112
              : 0;
        }

        updatedRef.ewt = calculateReferenceEWT(
          updatedRef.amountPaid,
          updatedRef.vat,
          updatedRef.taxationCode
        );

        return updatedRef;
      })
    );
  };

  const handleReferenceTaxationCodeChange = (id, taxationCode) => {
    setSalesInvoicePaymentDetails((prev) =>
      prev.map((ref) => {
        if (ref.id !== id) return ref;

        const updatedRef = {
          ...ref,
          taxationCode: taxationCode ?? null,
          taxationCodeId: taxationCode?.id ?? null,
        };

        updatedRef.ewt = calculateReferenceEWT(
          updatedRef.amountPaid,
          updatedRef.vat,
          updatedRef.taxationCode
        );

        return updatedRef;
      })
    );
  };

  const [preReference, setPreReference] = useState(null)
  const [showPreReferenceForm, setShowPreReferenceForm] = useState(false)

  const openPreReferenceForm = (_data) => {
    setShowPreReferenceForm(true)
    setSelectedSalesInvoicePaymentDetail(_data)
  }
  const closePreReferenceForm = () => {
    setShowPreReferenceForm(false)
  }

  const [showRemovePreReferenceForm, setShowRemovePreReferenceForm] = useState(false)

  const openRemoveReferenceForm = (_data) => {
    setShowRemovePreReferenceForm(true)
    setSelectedSalesInvoicePaymentDetail(_data)
  }
  const closeRemoveReferenceForm = () => {
    setShowRemovePreReferenceForm(false)
  }

  const handleRemoveReferenceTagging = () => {
    if (!selectedSalesInvoicePaymentDetail) return;

    setSalesInvoicePaymentDetails((prev) =>
      prev.map((ref) =>
        ref.id === selectedSalesInvoicePaymentDetail.id
          ? {
              ...ref,
              reference: null,
              referenceId: null,
              referenceNumber: "",
              totalAmount: 0,
            }
          : ref
      )
    );

    setSelectedSalesInvoicePaymentDetail(null);
  };

  useEffect(() => {
    if (preReference && selectedSalesInvoicePaymentDetail) {
      const newData = {
        reference: preReference ?? null,
        referenceId: preReference?.id ?? null,
        referenceNumber: preReference?.salesInvoiceNumber ?? "",
        totalAmount: preReference?.totalAmount ?? "",
      };

      setSalesInvoicePaymentDetails((prev) =>
        prev.map((ref) =>
          ref.id === selectedSalesInvoicePaymentDetail.id
            ? { ...ref, ...newData }
            : ref
        )
      );

      setPreReference(null);
      setSelectedSalesInvoicePaymentDetail(null);
    }
  }, [preReference, setSalesInvoicePaymentDetails, selectedSalesInvoicePaymentDetail]);

  const actionsSalesInvoicePaymentDetail = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleSalesInvoicePaymentDetailClick,
      visible: isEditable === false,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleSalesInvoicePaymentDetailClick,
      visible: isEditable === true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleSalesInvoicePaymentDetailClick,
      visible: isEditable === true,
    },
    
    {
      name: "AmountChange",
      function: handleReferenceAmountChange,
      visible: false,
    },
    {
      name: "TaxationCodeChange",
      function: handleReferenceTaxationCodeChange,
      visible: false,
    },
    {
      name: "ReferenceTagging",
      function: openPreReferenceForm,
      visible: false,
    },
    {
      name: "RemoveReferenceTagging",
      function: openRemoveReferenceForm,
      visible: false,
    },
  ];

  useEffect(() => {
    const _amount = salesInvoicePaymentDetails?.reduce((acc, item) => acc + (Number(item.amountPaid) || 0), 0) || 0;
    const _ewt = salesInvoicePaymentDetails?.reduce((acc, item) => acc + (Number(item.ewt) || 0), 0) || 0;
    setTotalSalesInvoiceAmount(_amount)
    setTotalEWT(_ewt)
  }, [salesInvoicePaymentDetails, setTotalSalesInvoiceAmount, setTotalEWT])
//#endregion 










//#region Chart Of Account
  const [selectedChartOfAccount, setSelectedChartOfAccount] = useState(null);
  const [currentPageChartOfAccount, setCurrentPageChartOfAccount] = useState(1);

  const headersChartOfAccount = [
    'ACCOUNT', 
    'DEBIT', 
    'CREDIT', 
    'ACTIONS'
  ]
  const accessorsChartOfAccount = [
    'glAccountName', 
    'debit', 
    'credit', 
    'actions'
  ]

  const [showAddChartOfAccountForm, setShowAddChartOfAccountForm] = useState(false);
  const openAddChartOfAccountForm = () => {
    setShowAddChartOfAccountForm(true);
  }
  const closeAddChartOfAccountForm = () => {
    setShowAddChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const [showUpdateChartOfAccountForm, setShowUpdateChartOfAccountForm] = useState(false);
  const openUpdateChartOfAccountForm = () => {
    setShowUpdateChartOfAccountForm(true);
  }
  const closeUpdateChartOfAccountForm = () => {
    setShowUpdateChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const editHandleChartOfAccountClick = async(_data) => {
    setLoading(true)

    setSelectedChartOfAccount(_data)

    setLoading(false)
    openUpdateChartOfAccountForm();
  }

  const [showViewChartOfAccountForm, setShowViewChartOfAccountForm] = useState(false);
  const openViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(true);
  }
  const closeViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const viewHandleChartOfAccountClick = (_data) => {
    setSelectedChartOfAccount(_data)
    openViewChartOfAccountForm();
  }

  const [showDeleteChartOfAccountForm, setShowDeleteChartOfAccountForm] = useState(false);
  const openDeleteChartOfAccountForm = () => {
    setShowDeleteChartOfAccountForm(true);
  }
  const closeDeleteChartOfAccountForm = () => {
    setShowDeleteChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const deleteHandleChartOfAccountClick = (_data) => {
    setSelectedChartOfAccount(_data)
    openDeleteChartOfAccountForm();
  }

  const handleDeleteChartOfAccount = () => {
    setChartOfAccounts(prev =>
      prev.filter(item =>
        (item.glAccountId  !== selectedChartOfAccount.glAccountId)
      )
    );
  };

  const [preAccounts, setPreAccounts] = useState([]);
  const [showPreAccountForm, setShowPreAccountForm] = useState(false);
  const openPreAccountForm = () => {
    setShowPreAccountForm(true);
  }
  const closePreAccountForm = () => {
    setShowPreAccountForm(false);
  }

  useEffect(() => {
    if (preAccounts.length > 0) {
      const newAccount = preAccounts.map((acc) => ({
        glAccount: acc,
        glAccountId: acc?.id ?? null,
        glAccountName: acc?.accountName ?? "",
        glAccountNumber: acc?.accountNumber ?? "",
        debit: 0,
        credit: 0,
      }));

      setChartOfAccounts((prev) => {
        const existingIds = new Set(
          prev.map((acc) => acc.glAccountId)
        );

        const uniqueAccounts = newAccount.filter(
          (acc) => !existingIds.has(acc.glAccountId)
        );

        return [...prev, ...uniqueAccounts];
      });
      setPreAccounts([])
    }
  }, [preAccounts, setChartOfAccounts]);

  const handleChartOfAccountAmountChange = (glAccountId, field, value) => {
    const amount = value === "" ? "" : Number(value);

    setChartOfAccounts((prev) => {
      const currentAccount = prev.find(
        (acc) => acc.glAccountId === glAccountId
      );

      if (!currentAccount) return prev;

      const oppositeField = field === "debit" ? "credit" : "debit";

      // Prevent entering an amount in both Debit and Credit.
      if (
        amount !== "" &&
        amount > 0 &&
        Number(currentAccount[oppositeField] || 0) > 0
      ) {
        setFailMessage(
          `This account already has a ${oppositeField} amount. Clear it first before entering ${field}.`
        );

        return prev;
      }

      return prev.map((acc) =>
        acc.glAccountId === glAccountId
          ? {
              ...acc,
              [field]: amount,
            }
          : acc
      );
    });
  };

  const insertDataAccount = {
    name: "Insert Account",
    icon: <PostAddIcon fontSize="small" />,
    className: "",
    function: openPreAccountForm
  }

  const actionsChartOfAccount = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleChartOfAccountClick,
      visible: isEditable === false,
    },
    { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleChartOfAccountClick,
      visible: isEditable === true,
    },
    { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleChartOfAccountClick,
      visible: isEditable === true,
    },
    
    {
      name: "AmountChange",
      function: handleChartOfAccountAmountChange,
      visible: false,
    },
  ];

  useEffect(() => {
    const _amount = chartOfAccounts?.reduce((acc, item) => acc + (Number(item.debit) || 0), 0) || 0;
    setTotalDebitChartOfAccountAmount(_amount)
  }, [chartOfAccounts, setTotalDebitChartOfAccountAmount])

  useEffect(() => {
    const _amount = chartOfAccounts?.reduce((acc, item) => acc + (Number(item.credit) || 0), 0) || 0;
    setTotalCreditChartOfAccountAmount(_amount)
  }, [chartOfAccounts, setTotalCreditChartOfAccountAmount])
//#endregion 












  const handleFileChange = async (e) => {
    const fileData = await HandleFileUpload(e);

    if (fileData) {
      setUploadedFile(fileData);
    }
  };


  useEffect(() => {
    const _amount = Number(paymentAmount) + Number(withholdingTax)

    setAmount(_amount ?? 0);
  }, [paymentAmount, withholdingTax, setAmount]);



  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Related Parties */}
                <>
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Related Parties</h3>
                  </div>

                  {isEditable && modalName !== "Update Payment"?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Customer <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Customer"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                          readOnly
                        />
                        {!customer ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                            <PersonSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Customer <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Customer"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                  </div>
                </>
              </div>
                
              {/* Wrap everything in a relative container */}
              <div className="relative mt-10">
                
                {/* The Overlay: Only shows if !customer */}
                {!customer && (
                  <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-50/60 backdrop-blur-[1px] rounded-xl border-2 border-dashed border-gray-200">
                    <div className="bg-white px-6 py-3 rounded-full shadow-xl border border-amber-200 flex items-center gap-3 animate-pulse">
                      <div className="bg-amber-100 p-1 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-600" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <span className="text-sm font-bold text-gray-700 uppercase tracking-tight">
                        Please select customer first
                      </span>
                    </div>
                  </div>
                )}

                {/* Your Content: We add opacity-40 if no customer to make it look "disabled" */}
                <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 transition-opacity duration-300 ${!customer ? 'opacity-40 pointer-events-none p-5' : 'opacity-100'}`}>
                  <>
                    <div className="space-y-4 md:col-span-2 mt-5">
                      <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Payment</h3>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Payment Number <span className="text-red-500">*</span>
                      </label>
                      <input
                        placeholder="0000000"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={paymentNumber}
                        onChange={(e) => setPaymentNumber(e.target.value)}
                        readOnly
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Payment Date <span className="text-red-500">*</span>
                      </label>
                      <DateSelect data={paymentDate} setData={setPaymentDate} isEditable={true}/>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Invoice Number
                      </label>
                      <input
                        placeholder="INV-000000"
                        className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                        value={manualInvoiceNumber}
                        onChange={(e) => setManualInvoiceNumber(e.target.value)}
                      />
                    </div>
                  </>
                </div>

                {customer && (
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* --- Section 2: Sales Invoice Payment Details (Expandable) --- */}
                      <div className="md:col-span-2 mt-10">
                        {/* Toggle Header Button */}
                        <button
                          type="button"
                          onClick={() => setShowSalesInvoicePaymentDetails(!showSalesInvoicePaymentDetails)}
                          className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showSalesInvoicePaymentDetails ? 'text-theme-color' : 'text-gray-400'}`}>
                              Sales to receive
                            </h3>
                            {/* Badge showing count */}
                            {salesInvoicePaymentDetails?.length > 0 && (
                              <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                {salesInvoicePaymentDetails.length}
                              </span>
                            )}
                          </div>
                          
                          <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showSalesInvoicePaymentDetails ? "rotate-180" : ""}`}>
                            <ExpandMoreIcon /> 
                          </div>
                        </button>

                        {/* Expandable Content Area */}
                        <AnimatePresence>
                          {showSalesInvoicePaymentDetails && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              className="overflow-hidden"
                            >
                              <div className="py-5 space-y-5">
                                {/* Add button */}
                                <div className="flex gap-3 w-full justify-start hidden">
                                  {isEditable &&
                                    <button 
                                      type="button"
                                      onClick={openAddSalesInvoicePaymentDetailForm} 
                                      className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                    >
                                      <AddCircleOutlineIcon fontSize="small" /> 
                                      New Reference
                                    </button>
                                  }
                                </div>

                                {/* List of Sales Invoice Payment Detail */}
                                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                                  <CreateTable
                                    tableName={"Sales Invoice Payment Detail"}
                                    headers={headersSalesInvoicePaymentDetail}
                                    accessors={accessorsSalesInvoicePaymentDetail}
                                    data={salesInvoicePaymentDetails}
                                    actions={actionsSalesInvoicePaymentDetail}
                                    currentPage={currentPageSalesInvoicePaymentDetail}
                                    setCurrentPage={setCurrentPageSalesInvoicePaymentDetail}
                                    itemsPerPage={10}
                                    totalItems={salesInvoicePaymentDetails?.length}
                                    hasInsert={true}
                                    insertData={insertData}
                                  />
                                </div>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>

                        {/* Summary when collapsed (Optional) */}
                        {!showSalesInvoicePaymentDetails && salesInvoicePaymentDetails?.length > 0 && (
                          <motion.p 
                            // initial={{ opacity: 0 }} 
                            // animate={{ opacity: 1 }} 
                            className="text-[11px] text-gray-400 mt-2 italic"
                          >
                            Click to view {salesInvoicePaymentDetails.length} line items...
                          </motion.p>
                        )}
                      </div>

                      {/* --- Section 3: Final Summary --- */}
                      <div className="md:col-span-2 hidden">
                        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                          
                          {/* Left Side: Details Breakdown */}
                          <div className="flex gap-4 w-full lg:w-auto">
                            <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                              <AccountBalanceWalletIcon className="text-theme-color" />
                            </div>
                            
                            <div className="flex-1 space-y-3">
                              <div>
                                <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                                  INVOICE SUMMARY
                                </p>
                                <p className="text-xs text-gray-500">Breakdown of all invoice</p>
                              </div>
                            </div>
                          </div>

                          {/* Right Side: Final Total & Status */}
                          <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                            <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                              INVOICE AMOUNT
                            </p>
                            <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                              <span className="text-4xl font-black text-gray-900 tracking-tight">
                                {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalSalesInvoiceAmount)}`}
                              </span>
                            </div>
                            <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                              <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                                {`Total EWT: ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalEWT)}`}
                              </p>
                            </div>

                            {/* Visual indicator of validation */}
                            {/* {amount > 0 ? (
                              <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                                <span className="mr-1">●</span> Ready to Save
                              </span>
                            ) : (
                              <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                                <span className="mr-1">○</span> No amount detected
                              </span>
                            )} */}
                          </div>
                        </div>
                      </div>

                      {/* --- Section 4: Chart of Accounts --- */}
                      <div className="md:col-span-2">
                        {/* Toggle Header Button */}
                        <button
                          type="button"
                          onClick={() => setShowChartOfAccounts(!showChartOfAccounts)}
                          className="flex items-center justify-between w-full border-b pb-2 group hover:border-theme-color transition-colors"
                        >
                          <div className="flex items-center gap-2">
                            <h3 className={`text-xs font-bold uppercase tracking-wider transition-colors ${showChartOfAccounts ? 'text-theme-color' : 'text-gray-400'}`}>
                              Chart of Accounts
                            </h3>
                            {/* Badge showing count */}
                            {chartOfAccounts?.length > 0 && (
                              <span className="bg-gray-200 text-gray-600 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                {chartOfAccounts.length}
                              </span>
                            )}
                          </div>
                          
                          <div className={`transform transition-transform duration-300 text-gray-400 group-hover:text-theme-color ${showChartOfAccounts ? "rotate-180" : ""}`}>
                            <ExpandMoreIcon /> 
                          </div>
                        </button>

                        {/* Expandable Content Area */}
                        <AnimatePresence>
                          {showChartOfAccounts && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              className="overflow-hidden"
                            >
                              <div className="py-5 space-y-5">
                                {/* Add button */}
                                <div className="flex gap-3 w-full justify-start hidden">
                                  {isEditable &&
                                    <button 
                                      type="button"
                                      onClick={openAddChartOfAccountForm} 
                                      className="flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                                    >
                                      <AddCircleOutlineIcon fontSize="small" /> 
                                      New Account
                                    </button>
                                  }
                                </div>

                                {/* List of Chart Of Accounts */}
                                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                                  <CreateTable
                                    tableName={"Chart Of Accounts Pre Payment"}
                                    headers={headersChartOfAccount}
                                    accessors={accessorsChartOfAccount}
                                    data={chartOfAccounts}
                                    actions={actionsChartOfAccount}
                                    currentPage={currentPageChartOfAccount}
                                    setCurrentPage={setCurrentPageChartOfAccount}
                                    itemsPerPage={10}
                                    totalItems={chartOfAccounts?.length}
                                    hasInsert={true}
                                    insertData={insertDataAccount}
                                  />
                                </div>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>

                        {/* Summary when collapsed (Optional) */}
                        {!showChartOfAccounts && chartOfAccounts?.length > 0 && (
                          <motion.p 
                            // initial={{ opacity: 0 }} 
                            // animate={{ opacity: 1 }} 
                            className="text-[11px] text-gray-400 mt-2 italic"
                          >
                            Click to view {chartOfAccounts.length} line items...
                          </motion.p>
                        )}
                      </div>

                      {/* --- Section 5: Final Summary --- */}
                      <div className="md:col-span-2">
                        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                          
                          {/* Left Side: Details Breakdown */}
                          <div className="flex gap-4 w-full lg:w-auto">
                            <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                              <AccountBalanceWalletIcon className="text-theme-color" />
                            </div>
                            
                            <div className="flex-1 space-y-3">
                              <div>
                                <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                                  Accounts Summary
                                </p>
                                <p className="text-xs text-gray-500">Breakdown of all accounts</p>
                                <span className="text-[16px] font-bold uppercase tracking-widest text-gray-400">
                                  {`To Receive: ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalSalesInvoiceAmount)}`}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Right Side: Final Total & Status */}
                          <div className="bg-white rounded-2xl flex flex-col justify-between items-start lg:items-center gap-2">
                            <div className="bg-white flex flex-col lg:flex-row justify-between items-start lg:items-center gap-10">
                              <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                                <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                                  DEBIT AMOUNT
                                </p>
                                <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                                  <span className="text-4xl font-black text-gray-900 tracking-tight">
                                    {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalDebitChartOfAccountAmount)}`}
                                  </span>
                                </div>
                              </div>

                              <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                                <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                                  CREDIT AMOUNT
                                </p>
                                <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                                  <span className="text-4xl font-black text-gray-900 tracking-tight">
                                    {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalCreditChartOfAccountAmount)}`}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* Visual indicator of validation */}
                            {/* {totalDebitChartOfAccountAmount === totalCreditChartOfAccountAmount && totalDebitChartOfAccountAmount === totalSalesInvoiceAmount ? (
                              <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                                <span className="mr-1">●</span> Ready to Save
                              </span>
                            ) : ( 
                              <span className="inline-flex items-center text-[10px] font-bold text-red-600 bg-red-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-red-100">
                                <span className="mr-1">○</span> Not tally
                              </span>
                            )} */}
                            {totalDebitChartOfAccountAmount === totalCreditChartOfAccountAmount && totalSalesInvoiceAmount > 0 && totalDebitChartOfAccountAmount === totalSalesInvoiceAmount && (
                              <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                                <span className="mr-1">●</span> Ready to Save
                              </span>
                            )}
                            {totalDebitChartOfAccountAmount !== totalCreditChartOfAccountAmount && totalSalesInvoiceAmount > 0 && ( 
                              <span className="inline-flex items-center text-[10px] font-bold text-red-600 bg-red-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-red-100">
                                <span className="mr-1">○</span> Not tally
                              </span>
                            )}
                            {totalDebitChartOfAccountAmount === totalCreditChartOfAccountAmount && totalSalesInvoiceAmount > totalDebitChartOfAccountAmount && ( 
                              <span className="inline-flex items-center text-[10px] font-bold text-red-600 bg-red-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-red-100">
                                <span className="mr-1">○</span> {`Not enough to pay ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalSalesInvoiceAmount)}`}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Payment Method <span className="text-red-500">*</span>
                        </label>
                        <PaymentMethodSelect2 data={paymentMethod} setData={setPaymentMethod} bank={bank} setBank={setBank} 
                          referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                          isEditable={true} 
                        />
                      </div>
                      
                      {paymentMethod?.id === CHECK_PAYMENT_METHOD && 
                        <>
                          <div>
                            <label className="block text-sm font-semibold mb-1 text-gray-700">
                              Bank <span className="text-red-500">*</span>
                            </label>
                            <div className="flex flex-row items-center">
                              <input
                                type="text"
                                placeholder="Select Bank"
                                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                                value={bank?.bankName || ""}
                                readOnly
                              />
                              {!bank ?
                                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openBankSelectForm}>
                                  <ManageSearchIcon className="text-white"/>
                                </button> 
                                :
                                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setBank(null)}>
                                  <RemoveCircleIcon className="text-white"/>
                                </button>
                              }
                            </div>
                          </div>
                          <div className="hidden">
                            <label className="block text-sm font-semibold mb-1 text-gray-700">
                              Checkbook <span className="text-red-500">*</span>
                            </label>
                            { salesInvoicePaymentHeader != null ?
                              <CheckbookFromUpdateSelect oldData={salesInvoicePaymentHeader} data={checkbook} setData={setCheckbook} bank={bank} 
                                referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                                isEditable={true} 
                              />
                              :
                              <CheckbookSelect data={checkbook} setData={setCheckbook} bank={bank} 
                                referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                                isEditable={true} 
                              />
                            }
                          </div>
                        </>
                      }

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Reference No <span className="text-red-500">*</span>
                        </label>
                        <input
                          placeholder="0000-0000"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={referenceNumber}
                          onChange={(e) => setReferenceNumber(e.target.value)}
                        />
                      </div>

                      <div className="hidden">
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Amount</label>
                        <input
                          type="number"
                          placeholder="0.00"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(amount || 0)}
                          </span>
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Payment Amount</label>
                        <input
                          type="number"
                          placeholder="0.00"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={paymentAmount}
                          onChange={(e) => setPaymentAmount(e.target.value)}
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(paymentAmount || 0)}
                          </span>
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Withholding Tax</label>
                        <input
                          type="number"
                          placeholder="0.00"
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={withholdingTax}
                          onChange={(e) => setWithholdingTax(e.target.value)}
                        />
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <span className="font-semibold text-gray-400 italic">
                            {getCurrency?.symbol ?? ""}
                            {FormatValueToDecimal(withholdingTax || 0)}
                          </span>
                        </div>
                      </div>

                      {/* --- Section 6: Payment Summary --- */}
                      {(() => {
                        const currencySymbol = getCurrency?.symbol || "";
                        const numSalesInvoiceAmount = Number(totalSalesInvoiceAmount || 0);
                        const numPayment = Number(paymentAmount || 0);
                        const numTax = Number(withholdingTax || 0);
                        
                        // Total of user's payment + withholding tax
                        const totalApplied = numPayment + numTax;
                        
                        // Difference check (allowing tiny decimal rounding variances)
                        const difference = numSalesInvoiceAmount - totalApplied;
                        const isTallied = Math.abs(difference) < 0.01;

                        return (
                          <div className="md:col-span-2">
                            <div className="relative overflow-hidden bg-white border border-gray-200/80 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-200">
                              <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                                
                                {/* Left Side: Header & Original Sales Invoice Breakdown */}
                                <div className="flex items-start gap-4 w-full lg:w-auto">
                                  <div className="p-3 rounded-xl bg-theme-color/10 text-theme-color ring-1 ring-theme-color/20 shrink-0">
                                    <AccountBalanceWalletIcon className="w-6 h-6" />
                                  </div>

                                  <div className="space-y-3">
                                    <div>
                                      <div className="flex items-center gap-2">
                                        <h4 className="text-sm font-semibold text-gray-900 tracking-tight">
                                          Payment Summary
                                        </h4>
                                        <span
                                          className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold border ${
                                            isTallied
                                              ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                                              : "bg-amber-50 text-amber-700 border-amber-200"
                                          }`}
                                        >
                                          {isTallied ? "Balanced" : "Pending Match"}
                                        </span>
                                      </div>
                                      <p className="text-xs text-gray-500 mt-0.5">
                                        Breakdown of all payment inputs & deductions
                                      </p>
                                    </div>

                                    {/* Sales Invoice Reference Stats */}
                                    <div className="flex flex-wrap items-center gap-3 pt-1">
                                      {/* Invoice Amount */}
                                      <div className="px-3.5 py-2 rounded-xl bg-gray-50 border border-gray-200/60">
                                        <span className="block text-[10px] font-semibold uppercase tracking-wider text-gray-400">
                                          Sales Amount Target
                                        </span>
                                        <span className="text-sm font-bold text-gray-800 tabular-nums">
                                          {currencySymbol} {FormatValueToDecimal(numSalesInvoiceAmount)}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="flex flex-wrap items-center gap-3 pt-1">
                                      {/* Total EWT Expected */}
                                      <div className="px-3.5 py-2 rounded-xl bg-green-50/60 border border-green-200/50">
                                        <span className="block text-[10px] font-semibold uppercase tracking-wider text-green-600/80">
                                          Expected Payment
                                        </span>
                                        <span className="text-sm font-bold text-green-900 tabular-nums">
                                          {currencySymbol} {FormatValueToDecimal(numSalesInvoiceAmount - totalEWT)}
                                        </span>
                                      </div>

                                      <div className="px-3.5 py-2 rounded-xl bg-amber-50/60 border border-amber-200/50">
                                        <span className="block text-[10px] font-semibold uppercase tracking-wider text-amber-600/80">
                                          Expected EWT
                                        </span>
                                        <span className="text-sm font-bold text-amber-900 tabular-nums">
                                          {currencySymbol} {FormatValueToDecimal(totalEWT)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Right Side: Actual Inputs Applied + Total + Tally Status */}
                                <div className="w-full lg:w-auto p-4 rounded-xl bg-gray-50/80 border border-gray-200/70 flex flex-col gap-2.5 min-w-[280px]">
                                  
                                  {/* Input Line Items */}
                                  <div className="space-y-1.5 text-xs">
                                    <div className="flex justify-between items-center text-gray-500">
                                      <span>Payment Amount</span>
                                      <span className="font-semibold text-gray-800 tabular-nums">
                                        {currencySymbol} {FormatValueToDecimal(numPayment)}
                                      </span>
                                    </div>

                                    <div className="flex justify-between items-center text-gray-500">
                                      <span>Withholding Tax</span>
                                      <span className="font-semibold text-gray-800 tabular-nums">
                                        + {currencySymbol} {FormatValueToDecimal(numTax)}
                                      </span>
                                    </div>
                                  </div>

                                  {/* Total Applied */}
                                  <div className="border-t border-gray-200/80 pt-2 flex justify-between items-baseline">
                                    <span className="text-xs font-bold uppercase tracking-wider text-gray-700">
                                      Total Applied
                                    </span>
                                    <span className="text-lg font-extrabold text-theme-color tabular-nums">
                                      {currencySymbol} {FormatValueToDecimal(totalApplied)}
                                    </span>
                                  </div>

                                  {/* Dynamic Tally Indicator */}
                                  <div
                                    className={`flex items-center justify-between px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors ${
                                      isTallied
                                        ? "bg-emerald-50 text-emerald-800 border-emerald-200"
                                        : "bg-rose-50 text-rose-800 border-rose-200"
                                    }`}
                                  >
                                    <div className="flex items-center gap-1.5">
                                      <span
                                        className={`w-2 h-2 rounded-full ${
                                          isTallied ? "bg-emerald-500 animate-pulse" : "bg-rose-500"
                                        }`}
                                      />
                                      <span>
                                        {isTallied ? "Tallies with Sales" : "Does Not Tally"}
                                      </span>
                                    </div>

                                    {!isTallied && (
                                      <span className="font-semibold tabular-nums text-[11px]">
                                        {difference > 0 ? "Under by " : "Over by "}
                                        {currencySymbol} {FormatValueToDecimal(Math.abs(difference))}
                                      </span>
                                    )}
                                  </div>

                                </div>

                              </div>
                            </div>
                          </div>
                        );
                      })()}

                      {/* Full Width: Notes */}
                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold mb-1 text-gray-700">Notes</label>
                        <textarea
                          rows="3"
                          placeholder="Enter any additional details or remarks..."
                          className="text-sm w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color transition"
                          value={notes}
                          onChange={(e) => setNotes(e.target.value)}
                          readOnly={!isEditable}
                        />
                      </div>
                    </div>

                    <div className="mt-6 space-y-2">
                      <label className="text-[11px] font-bold uppercase tracking-widest text-gray-400 ml-1">Attachment</label>
                      
                      <div className={`relative group transition-all duration-200 rounded-xl border-2 border-dashed 
                        ${uploadedFile ? 'border-theme-color/30 bg-theme-color/5' : 'border-gray-200 hover:border-theme-color/50 bg-gray-50/50 hover:bg-white'}`}>
                        
                        {/* Hidden Input - clickable over the whole area */}
                        {isEditable && (
                          <input
                            type="file"
                            onChange={handleFileChange}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                          />
                        )}
      
                        <div className="p-4 flex items-center justify-between gap-4">
                          <div className="flex items-center gap-3">
                            {/* Icon based on state */}
                            <div className={`p-2.5 rounded-lg ${uploadedFile ? 'bg-theme-color text-white' : 'bg-gray-200 text-gray-500'}`}>
                              {uploadedFile ? (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                              ) : (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                              )}
                            </div>
      
                            <div>
                              <p className={`text-sm font-semibold truncate max-w-[200px] ${uploadedFile ? 'text-gray-800' : 'text-gray-500'}`}>
                                {uploadedFile ? uploadedFile.fileName : "Click to upload file"}
                              </p>
                              <p className="text-[11px] text-gray-400 font-medium">
                                {uploadedFile ? (uploadedFile.contentType || "Document") : "Support any file format"}
                              </p>
                            </div>
                          </div>
      
                          {/* Action Button */}
                          {uploadedFile && (
                            <button
                              type="button"
                              onClick={(e) => { e.stopPropagation(); DownloadFile(uploadedFile); }}
                              className="relative z-20 flex items-center gap-2 px-4 py-2 text-xs font-bold text-theme-color bg-white border border-theme-color/20 rounded-lg shadow-sm hover:bg-theme-color hover:text-white transition-all"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                              </svg>
                              DOWNLOAD
                            </button>
                          )}
                        </div>
                      </div>
                      
                      {!uploadedFile && <p className="text-[10px] text-gray-400 italic ml-1">* No file attached yet</p>}
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />

      <AddUpdateReferenceModal 
        visible={showAddSalesInvoicePaymentDetailForm} 
        onClose={closeAddSalesInvoicePaymentDetailForm}
        modalName={"Add Reference"}
        parentModalName={modalName}
        data={selectedSalesInvoicePaymentDetail}
        salesInvoicePaymentHeader={salesInvoicePaymentHeader}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer}
        isEditable={true}
      />

      <AddUpdateReferenceModal 
        visible={showUpdateSalesInvoicePaymentDetailForm} 
        onClose={closeUpdateSalesInvoicePaymentDetailForm}
        modalName={"Update Reference"}
        parentModalName={modalName}
        data={selectedSalesInvoicePaymentDetail}
        salesInvoicePaymentHeader={salesInvoicePaymentHeader}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer}
        isEditable={true}
      />

      <AddUpdateReferenceModal 
        visible={showViewSalesInvoicePaymentDetailForm} 
        onClose={closeViewSalesInvoicePaymentDetailForm}
        modalName={"View Reference"}
        parentModalName={modalName}
        data={selectedSalesInvoicePaymentDetail}
        salesInvoicePaymentHeader={salesInvoicePaymentHeader}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer}
        isEditable={false}
      />

      <AddUpdateChartOfAccountsModal 
        visible={showAddChartOfAccountForm} 
        onClose={closeAddChartOfAccountForm}
        modalName={"Add Account"}
        parentModalName={modalName}
        data={selectedChartOfAccount}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer}
        isEditable={true}
      />

      <AddUpdateChartOfAccountsModal 
        visible={showUpdateChartOfAccountForm} 
        onClose={closeUpdateChartOfAccountForm}
        modalName={"Update Account"}
        parentModalName={modalName}
        data={selectedChartOfAccount}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer}
        isEditable={true}
      />

      <AddUpdateChartOfAccountsModal 
        visible={showViewChartOfAccountForm} 
        onClose={closeViewChartOfAccountForm}
        modalName={"View Account"}
        parentModalName={modalName}
        data={selectedChartOfAccount}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer}
        isEditable={false}
      />
      
      <ConfirmationModal 
        visible={showDeleteSalesInvoicePaymentDetailForm} 
        onClose={closeDeleteSalesInvoicePaymentDetailForm} 
        onSave={handleDeleteSalesInvoicePaymentDetail} 
        modalName={"Delete"} 
        message={`Do you want to remove this?.`}
      />
      
      <ConfirmationModal 
        visible={showDeleteChartOfAccountForm} 
        onClose={closeDeleteChartOfAccountForm} 
        onSave={handleDeleteChartOfAccount} 
        modalName={"Delete"} 
        message={`Do you want to remove this account [ ${selectedChartOfAccount?.glAccountName} ]?.`}
      />

      <BankSelect
        visible={showBankSelectForm}
        onClose={closeBankSelectForm}
        modalName={"Select Bank"}
        data={bank} // full current data array
        setData={setBank}
      />

      <PaymentTypeModal
        isOpen={showPaymentTypeModal}
        onClose={closePaymentTypeModal}
        onAdvancePayment={addAdvancePayment}
        onChooseReferences={openPreReferencesForm}
      />

      <SalesPerCustomerSelect 
        visible={showPreReferenceForm} 
        onClose={closePreReferenceForm}
        modalName={"Select Reference"}
        data={preReference} setData={setPreReference}
        customer={customer}
      />

      <ConfirmationModal 
        visible={showRemovePreReferenceForm} 
        onClose={closeRemoveReferenceForm} 
        onSave={handleRemoveReferenceTagging} 
        modalName={"Delete"} 
        message={`Do you want to remove this tagging?.`}
      />

      <SalesPerCustomerMultipleSelect 
        visible={showPreReferencesForm} 
        onClose={closePreReferencesForm}
        modalName={"Select References"}
        data={preReferences} setData={setPreReferences}
        customer={customer}
      />

      <ChartOfAccountsMultipleSelect 
        visible={showPreAccountForm} 
        onClose={closePreAccountForm}
        modalName={"Select Account"}
        data={preAccounts} setData={setPreAccounts}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
      
      { loading && <Loading />}
    </>
  );
};
const ViewModal = ({
  visible, onClose, onSave, modalName,
  salesInvoicePaymentHeader,
  salesInvoicePaymentDetails, setSalesInvoicePaymentDetails,
  customer, setCustomer,
  paymentNumber, setPaymentNumber,
  depositToAccount, setDepositToAccount,
  amount, setAmount,
  paymentDate, setPaymentDate,
  paymentMethod, setPaymentMethod,
  referenceNumber, setReferenceNumber,
  notes, setNotes,
  uploadedFile, setUploadedFile,

  manualInvoiceNumber, setManualInvoiceNumber,
  paymentAmount, setPaymentAmount,
  withholdingTax, setWithholdingTax,

  isEditable
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const printRef = useRef();
  const [isDownloading, setIsDownloading] = useState(false);

  // Helper for currency formatting
  const formatVal = (num) => {
    return typeof FormatValueToDecimal === "function" 
      ? FormatValueToDecimal(num) 
      : Number(num || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
  };

  const downloadHandleClick = async () => {
    const element = printRef.current;
    if (!element) return;

    setIsDownloading(true);
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        windowWidth: 1200,
        windowHeight: element.scrollHeight
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`Payment_Received_${'Export'}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleSubmit = async () => {
    await downloadHandleClick();
  };

  const closeModal = () => {
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar bg-gray-100">
              <div
                ref={printRef}
                className="max-w-4xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-12 min-h-[800px] flex flex-col"
              >
                {/* 1. TOP HEADER */}
                <div className="flex justify-between items-start border-b-4 border-theme-color pb-8 mb-10">
                  <div>
                    <h1 className="text-4xl font-black text-theme-color tracking-tighter mb-2">PAYMENT RECEIVED</h1>
                    <div className="flex items-center gap-4">
                      <div className="flex flex-col">
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Payment Method</span>
                        <span className="text-sm font-bold text-gray-700">{paymentMethod?.description || "N/A"}</span>
                      </div>
                      <div className="h-8 w-[1px] bg-gray-200 mx-2"></div>
                      <div className="flex flex-col">
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Reference #</span>
                        <span className="text-sm font-bold text-gray-700">{referenceNumber || "---"}</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Voucher Number</p>
                    <p className="text-2xl font-mono font-bold text-gray-900">#{paymentNumber || 'DRAFT'}</p>
                    <p className="text-lg font-mono text-gray-900">#{manualInvoiceNumber || ''}</p>
                    <p className="mt-4 text-[10px] font-bold text-gray-400 uppercase tracking-widest">Payment Date</p>
                    <p className="text-sm font-bold text-gray-800">{paymentDate ? new Date(paymentDate).toLocaleDateString('en-US', { dateStyle: 'long' }) : 'N/A'}</p>
                  </div>
                </div>

                {/* 2. PAYMENT SOURCE & DESTINATION GRID */}
                <div className="grid grid-cols-2 gap-0 mb-12 border border-gray-100 rounded-2xl overflow-hidden shadow-sm">
                  {/* From: Account */}
                  <div className="p-6 bg-gray-50 border-r border-gray-100">
                    <h3 className="text-[10px] font-black text-theme-color uppercase tracking-[0.2em] mb-4">Deposit To (Payee)</h3>
                    <div className="flex items-center gap-4">
                      <div className="bg-theme-color text-white p-3 rounded-lg">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-bold text-gray-900 text-lg leading-tight">{depositToAccount?.accountName || "Bank/Cash Account"}</p>
                      </div>
                    </div>
                  </div>

                  {/* To: Customer */}
                  <div className="p-6 bg-white">
                    <h3 className="text-[10px] font-black text-theme-color uppercase tracking-[0.2em] mb-4">Received From (Source)</h3>
                    <div>
                      <p className="font-bold text-gray-900 text-lg leading-tight">{customer?.name1 || customer?.Name1 || "N/A"}</p>
                      <p className="text-sm text-gray-500">{customer?.name2 || customer?.Name2}</p>
                      <p className="text-xs text-gray-400 mt-1 font-mono">Customer ID: {customer?.customerId || customer?.CustomerId}</p>
                    </div>
                  </div>
                </div>

                {/* 3. SALES SETTLED TABLE */}
                <div className="flex-grow">
                  <div className="mb-4">
                    <h3 className="text-[11px] font-bold text-gray-900 uppercase tracking-widest flex items-center gap-2">
                      Settlement Details
                      <span className="h-[1px] flex-1 bg-gray-100"></span>
                    </h3>
                  </div>
                  <table className="w-full">
                    <thead>
                      <tr className="border-b-2 border-gray-900">
                        <th className="py-3 text-left text-[10px] font-bold uppercase tracking-widest text-gray-400">Ref. No.</th>
                        <th className="py-3 text-right text-[10px] font-bold uppercase tracking-widest text-gray-400">Original Due</th>
                        <th className="py-3 text-right text-[10px] font-bold uppercase tracking-widest text-gray-900">Amount Received</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {salesInvoicePaymentDetails?.length > 0 ? (
                        salesInvoicePaymentDetails.map((detail, idx) => {
                          const orders = detail.reference?.orders || [];
                          const visibleCount = 2; // Number of items visible directly in the cell
                          const visibleOrders = orders.slice(0, visibleCount);

                          return (
                            <tr key={idx} className="hover:bg-gray-50/50">
                              <td className="py-4">
                                <p className="text-sm font-bold text-gray-800">{detail.referenceNumber || detail.SalesInvoiceNumber || '---'}</p>
                                {visibleOrders.map((order, index) => (
                                  <div
                                    key={order.id || index}
                                    className="flex items-center justify-between gap-2 px-2 py-1 bg-gray-50 rounded-md border border-gray-100 hover:bg-gray-100/80 transition-colors"
                                  >
                                    <span className="font-mono text-xs font-semibold text-gray-700 truncate" title={order.doNumber}>
                                      {order.doNumber || "N/A"}
                                    </span>
                                  </div>
                                ))}
                              </td>
                              <td className="py-4 text-right text-sm font-medium text-gray-400">
                                {getCurrency?.symbol} {formatVal(detail.amountDueBeforePayment)}
                              </td>
                              <td className="py-4 text-right text-sm font-bold text-gray-900">
                                {getCurrency?.symbol} {formatVal(detail.amountPaid)}
                              </td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr>
                          <td colSpan="4" className="py-10 text-center text-sm text-gray-400 italic">No sales invoice details associated with this payment</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* 4. TOTALS & FOOTER */}
                <div className="mt-10 pt-10 border-t-2 border-gray-900">
                  <div className="flex justify-between items-start">
                    <div className="max-w-md">
                      <h4 className="text-[10px] font-black text-gray-900 uppercase tracking-widest mb-2">Remarks / Notes</h4>
                      <p className="text-xs text-gray-500 leading-relaxed italic border-l-4 border-theme-color pl-4">
                        {notes || "No additional payment remarks."}
                      </p>
                    </div>

                    <div className=" text-gray-800 p-8 text-right min-w-[280px]">
                      <p className="text-[10px] font-bold uppercase tracking-[0.2em] mb-1 opacity-80">Total Amount Received</p>
                      <p className="text-4xl font-black">
                        {getCurrency?.symbol} {formatVal(amount)}
                      </p>
                      <div className="mt-4 pt-4 border-t border-white/20">
                        <p className="text-[9px] italic opacity-70">Amount in words available upon request</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={isDownloading}
                className={`px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm flex items-center gap-2 ${isDownloading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'}`}
              >
                {isDownloading ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                      Generating PDF...
                    </>
                ) : 'Download PDF'}
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
//#endregion














//#region Reference
const AddUpdateReferenceModal = ({
  visible, onClose, onSave, modalName, parentModalName,
  data, salesInvoicePaymentHeader,
  salesInvoicePaymentDetails, setSalesInvoicePaymentDetails,
  isEditable,
  customer,
  isReferenceTagging
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [reference, setReference] = useState(null);
  const [loading, setLoading] = useState(false);
  const [amountPaid, setAmountPaid] = useState(0);
  const [vatableAmount, setVatableAmount] = useState(0);
  const [vat, setVat] = useState(0);
  const [ewt, setEWT] = useState(0);
  const [taxationCode, setTaxationCode] = useState(null);
  
  useEffect(() => {
    const foundDetail = salesInvoicePaymentDetails.find(i => i.referenceId === reference?.id)

    setTaxationCode(foundDetail?.taxationCode ?? taxationCode)
  }, [salesInvoicePaymentDetails, reference, taxationCode])

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    // if (!salesInvoice) {
    //   setFailMessage("Please fill up all required fields (Sales Invoice Account, Paid Through, and Amount).");
    //   return;
    // }

    if(modalName === "Add Reference"){
      const foundData = salesInvoicePaymentDetails.find(i => i.referenceId === reference?.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      let referenceType = "Invoice"

      const newData = {
        referenceId: reference?.id ?? null,
        reference: reference ?? null,
        referenceNumber: reference?.salesInvoiceNumber ?? reference?.referenceNumber,
        referenceType: referenceType,
        // orderNumber: salesInvoice?.orderNumber ?? "",
        // dueDate: salesInvoice?.dueDate ?? null,
        totalAmount: reference?.totalAmount ?? 0,
        // amountDue: salesInvoice?.amountDue ?? 0,
        amountDueBeforePayment: reference?.totalAmount ?? 0,
        // creditNotesAmount: salesInvoice?.creditNotesAmount ?? 0,
        amountPaid: Number(amountPaid),
        taxationCodeId: taxationCode?.id,
        taxationCode: taxationCode,
        ewt: ewt,
      }

      setSalesInvoicePaymentDetails((prev) => [...prev, newData])
    }

    if(modalName === "Update Reference"){
      const foundData = salesInvoicePaymentDetails.find(i => i.referenceId === reference?.id && data?.referenceId !== reference?.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      let referenceType = "Invoice"

      const newData = {
        referenceId: reference?.id ?? null,
        reference: reference ?? null,
        referenceNumber: reference?.salesInvoiceNumber ?? reference?.referenceNumber,
        referenceType: referenceType,
        // orderNumber: salesInvoice?.orderNumber ?? "",
        // dueDate: salesInvoice?.dueDate ?? null,
        totalAmount: reference?.totalAmount ?? 0,
        // amountDue: salesInvoice?.amountDue ?? 0,
        amountDueBeforePayment: reference?.totalAmount ?? 0,
        // creditNotesAmount: salesInvoice?.creditNotesAmount ?? 0,
        amountPaid: Number(amountPaid),
        taxationCodeId: taxationCode?.id,
        taxationCode: taxationCode,
        ewt: ewt,
      }

      setSalesInvoicePaymentDetails(prev =>
        prev.map(item =>
          item.id === data?.id
            ? newData
            : item
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setSuccessMessage("");
    setFailMessage("");
    setReference(null);
    setLoading(false);
    setAmountPaid(0)
    setVatableAmount(0)
    setVat(0)
    setEWT(0)
    setTaxationCode(null)
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible){
      setReference(data?.reference?.id ? data?.reference : null)
      setAmountPaid(data?.amountPaid ?? 0)
      setTaxationCode(data?.taxationCode ?? null)
    }
  }, [visible, data])

  useEffect(() => {
    const total = Number(amountPaid) || 0;

    let vatable = 0;
    let vatValue = 0;

    if (reference?.customerPriceType === "Inclusive") {
      vatable = total / 1.12;
      vatValue = total - vatable;
    } else {
      vatable = total;
    }

    setVatableAmount(vatable);
    setVat(vatValue);
  }, [reference?.customerPriceType, isEditable, amountPaid]);

  useEffect(() => {
    if (taxationCode) {
      const ewtRate = Number((taxationCode?.rate ?? 0) / 100);
      let ewtValue = 0;
      
      ewtValue = vatableAmount * ewtRate;
      setEWT(ewtValue);
    }
  }, [taxationCode, vatableAmount]);

  const [showReferenceForm, setShowReferenceForm] = useState(false);
  const openReferenceForm = () => {
    setShowReferenceForm(true);
  }
  const closeReferenceForm = () => {
    setShowReferenceForm(false);
  }

  const [showOrderSelectForm, setShowOrderSelectForm] = useState(false);
  const openOrderSelectForm = () => {
    setShowOrderSelectForm(true);
  }
  const closeOrderSelectForm = () => {
    setShowOrderSelectForm(false);
  }

  const [showSalesInvoiceSelectForm, setShowSalesInvoiceSelectForm] = useState(false);
  const openSalesInvoiceSelectForm = () => {
    setShowSalesInvoiceSelectForm(true);
  }
  const closeSalesInvoiceSelectForm = () => {
    setShowSalesInvoiceSelectForm(false);
  }

  const handleReferenceTagging = async () => {
    const _data = {
      referenceId: reference?.id ?? null,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/SalesInvoicePayment/update/detail/${data.id}`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });

      let referenceType = "Invoice"
      
      const newData = {
        referenceId: reference?.id ?? null,
        reference: reference ?? null,
        referenceNumber: reference?.salesInvoiceNumber ?? reference?.referenceNumber,
        referenceType: referenceType,
        // orderNumber: salesInvoice?.orderNumber ?? "",
        // dueDate: salesInvoice?.dueDate ?? null,
        totalAmount: reference?.totalAmount ?? 0,
        // amountDue: salesInvoice?.amountDue ?? 0,
        amountDueBeforePayment: reference?.totalAmount ?? 0,
        // creditNotesAmount: salesInvoice?.creditNotesAmount ?? 0,
        amountPaid: Number(amountPaid),
        taxationCodeId: taxationCode?.id,
        taxationCode: taxationCode,
        ewt: ewt,
      }

      setSalesInvoicePaymentDetails(prev =>
        prev.map(item => {
          return (
            item.id === data?.id
              ? newData
              : item
          )}
        )
      );

      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to update data: ${errorMessage}`);
    } finally {
      setLoading(false);
      closeModal();
    }
  }

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                  </div>

                  { isEditable ?
                    <>
                      <div>
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Reference
                        </label>
                        <div className="flex flex-row items-center">
                          <input
                            type="text"
                            placeholder="Select Account"
                            className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                            value={reference ? reference?.salesInvoiceNumber || reference?.referenceNumber : ""}
                            readOnly
                          />
                          {!reference ?
                            <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openSalesInvoiceSelectForm}>
                              <ManageSearchIcon className="text-white"/>
                            </button> 
                            :
                            <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setReference(null)}>
                              <RemoveCircleIcon className="text-white"/>
                            </button>
                          }
                        </div>
                      </div>
                      <div className="hidden">
                        <label className="block text-sm font-semibold mb-1 text-gray-700">
                          Reference
                        </label>
                        <div className="flex flex-row items-center">
                          <input
                            type="text"
                            placeholder="Select Account"
                            className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                            value={reference ? reference?.salesInvoiceNumber || reference?.referenceNumber : ""}
                            readOnly
                          />
                          {!reference ?
                            <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openReferenceForm}>
                              <ManageSearchIcon className="text-white"/>
                            </button> 
                            :
                            <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setReference(null)}>
                              <RemoveCircleIcon className="text-white"/>
                            </button>
                          }
                        </div>
                      </div>
                    </>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Reference
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Reference"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={reference ? reference?.salesInvoiceNumber || reference?.referenceNumber : ""}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Amount <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="number"
                        disabled={!isEditable || isReferenceTagging}
                        className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={amountPaid}
                        onChange={(e) => setAmountPaid(e.target.value)}
                        readOnly={!isEditable}
                      />
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(amountPaid || 0)}
                      </span>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-stretch gap-8">
                      <div className="flex gap-5 flex-1">
                        {/* Icon Section */}
                        <div className="hidden sm:block">
                          <div className="bg-slate-50 p-3 rounded-xl border border-slate-100">
                            <AccountBalanceWalletIcon className="text-slate-600" />
                          </div>
                        </div>

                        <div className="flex-1">
                          <div className="mb-4">
                            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-tight">Payment Summary</h3>
                            <p className="text-xs text-gray-500">Breakdown of taxes and collection status</p>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-4 border-t border-gray-100">
                            {/* Group 1: Billing & Taxes */}
                            <div className="space-y-2.5">
                              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Accounting Details</p>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">Vatable Amount</span>
                                <span className="font-semibold text-gray-700">{getCurrency?.symbol} {FormatValueToDecimal(vatableAmount)}</span>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">VAT (12%)</span>
                                <span className="font-semibold text-gray-700">{getCurrency?.symbol} {FormatValueToDecimal(vat || 0)}</span>
                              </div>
                              <div className="flex justify-between text-xs w-full">
                                <div className="w-full flex flex-col gap-2">
                                  <span className="text-gray-500">Taxation Code</span>
                                  <div className="w-full">
                                    <TaxationCodeSelect data={taxationCode} setData={setTaxationCode} isEditable={isEditable && !isReferenceTagging}/>
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">EWT</span>
                                <span className="font-semibold text-orange-600">({getCurrency?.symbol} {FormatValueToDecimal(ewt || 0)})</span>
                              </div>
                            </div>

                            {/* Group 2: Payment Status */}
                            <div className="space-y-2.5 border-t md:border-t-0 md:border-l md:pl-8 border-gray-100 pt-4 md:pt-0">
                              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Payment Progress</p>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">Total Sales</span>
                                <span className="font-bold text-gray-900">{getCurrency?.symbol} {FormatValueToDecimal(reference?.totalAmount)}</span>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">Amount Paid</span>
                                <span className="font-bold text-green-600">
                                  {getCurrency?.symbol} {FormatValueToDecimal(modalName === "Update Invoice" ? Number(reference?.totalAmount) - Number(reference?.amountDue) : reference?.amountPaid)}
                                </span>
                              </div>
                              <div className="flex justify-between text-xs">
                                <span className="text-gray-500">Balance</span>
                                <span className="font-bold text-red-500">{getCurrency?.symbol} {FormatValueToDecimal(reference?.amountDue)}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Summary Side Card */}
                      <div className="lg:w-64 bg-slate-50 rounded-xl p-5 flex flex-col justify-center items-center lg:items-end border border-slate-100">
                        <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">Total Amount Due</p>
                        <div className="text-3xl font-black text-slate-900 tracking-tight">
                          {getCurrency?.symbol} {FormatValueToDecimal(reference?.amountDue)}
                        </div>
                        <div className={`mt-2 px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase ${reference?.amountDue > 0 ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                          {reference?.amountDue > 0 ? 'Pending Payment' : 'Fully Paid'}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <>
                  { isReferenceTagging ?
                    <button
                      onClick={handleReferenceTagging}
                      className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                    >
                      Save Transaction
                    </button>
                    :
                    <button
                      onClick={handleSubmit}
                      className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                    >
                      Save Transaction
                    </button>
                  }
                </>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
      
      {parentModalName === "Update Payment" ?
        <SalesPerCustomerTamperedSelect 
          visible={showSalesInvoiceSelectForm} 
          onClose={closeSalesInvoiceSelectForm}
          modalName={"Select Sales Invoices"}
          data={reference} setData={setReference}
          salesInvoicePaymentHeader={salesInvoicePaymentHeader}
          customer={customer}
        /> 
      :
        <SalesPerCustomerSelect 
          visible={showSalesInvoiceSelectForm} 
          onClose={closeSalesInvoiceSelectForm}
          modalName={"Select Sales Invoices"}
          data={reference} setData={setReference}
          customer={customer}
        />
      }

      <DeliveryOrderCustomerSelect 
        visible={showOrderSelectForm} 
        onClose={closeOrderSelectForm}
        modalName={"Select Available DO"}
        data={reference} setData={setReference}
        customer={customer}
      />

      <PaymentReferenceTypeModal
        visible={showReferenceForm}
        onClose={closeReferenceForm}
        handleOrderSubmit={openOrderSelectForm}
        handleInvoiceSubmit={openSalesInvoiceSelectForm}
        modalName="Payment Reference"
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
const ViewReferenceModal = ({
  visible, onClose, onSave, modalName,
  salesInvoicePaymentDetails, setSalesInvoicePaymentDetails,
  salesInvoicePaymentHeader, customer
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [amount, setAmount] = useState(0);
  const [totalSalesInvoiceAmount, setTotalSalesInvoiceAmount] = useState(0);

  const [currentPageSalesInvoicePaymentDetail, setCurrentPageSalesInvoicePaymentDetail] = useState(1);

  const [isEditState, setIsEditState] = useState(false);
  const [revertedDetails, setRevertedDetails] = useState([])
  const onEditState = () => {
    setRevertedDetails(salesInvoicePaymentDetails)
    setIsEditState(true);
  }
  const offEditState = () => {
    setIsEditState(false);
    setRevertedDetails([])
    setSalesInvoicePaymentDetails(revertedDetails)
  }

  const closeModal = () => {
    onClose();

    setCurrentPageSalesInvoicePaymentDetail(1)
    setAmount(0);
    setTotalSalesInvoiceAmount(0);
    offEditState();
    
    setLoading(false);
    setSuccessMessage("");
    setFailMessage("");
  };

  const [selectedSalesInvoicePaymentDetail, setSelectedSalesInvoicePaymentDetail] = useState(null);

  const [showViewSalesInvoicePaymentDetailForm, setShowViewSalesInvoicePaymentDetailForm] = useState(false);
  const openViewSalesInvoicePaymentDetailForm = () => {
    setShowViewSalesInvoicePaymentDetailForm(true);
  }
  const closeViewSalesInvoicePaymentDetailForm = () => {
    setShowViewSalesInvoicePaymentDetailForm(false);
    setSelectedSalesInvoicePaymentDetail(null)
  }

  const viewHandleSalesInvoicePaymentDetailClick = (_data) => {
    setSelectedSalesInvoicePaymentDetail(_data)
    openViewSalesInvoicePaymentDetailForm();
  }

  const [showAddSalesInvoicePaymentDetailForm, setShowAddSalesInvoicePaymentDetailForm] = useState(false);
  const openAddSalesInvoicePaymentDetailForm = () => {
    setShowAddSalesInvoicePaymentDetailForm(true);
  }

  const closeAddSalesInvoicePaymentDetailForm = () => {
    setShowAddSalesInvoicePaymentDetailForm(false);
    setSelectedSalesInvoicePaymentDetail(null)
  }

  const [showUpdateSalesInvoicePaymentDetailForm, setShowUpdateSalesInvoicePaymentDetailForm] = useState(false);
  const openUpdateSalesInvoicePaymentDetailForm = () => {
    setShowUpdateSalesInvoicePaymentDetailForm(true);
  }
  const closeUpdateSalesInvoicePaymentDetailForm = () => {
    setShowUpdateSalesInvoicePaymentDetailForm(false);
    setSelectedSalesInvoicePaymentDetail(null)
  }

  const editHandleSalesInvoicePaymentDetailClick = async(_data) => {
    setSelectedSalesInvoicePaymentDetail(_data)
    openUpdateSalesInvoicePaymentDetailForm();
  }

  const [showDeleteSalesInvoicePaymentDetailForm, setShowDeleteSalesInvoicePaymentDetailForm] = useState(false);
  const openDeleteSalesInvoicePaymentDetailForm = () => {
    setShowDeleteSalesInvoicePaymentDetailForm(true);
  }
  const closeDeleteSalesInvoicePaymentDetailForm = () => {
    setShowDeleteSalesInvoicePaymentDetailForm(false);
    setSelectedSalesInvoicePaymentDetail(null)
  }

  const deleteHandleSalesInvoicePaymentDetailClick = (_data) => {
    setSelectedSalesInvoicePaymentDetail(_data)
    openDeleteSalesInvoicePaymentDetailForm();
  }

  const handleDeleteSalesInvoicePaymentDetail = () => {
    setSalesInvoicePaymentDetails(prev =>
      prev.filter(item =>
        (item.referenceNumber  !== selectedSalesInvoicePaymentDetail.referenceNumber)
      )
    );
  };


  const headersSalesInvoicePaymentDetail = [
    'INVOICE NUMBER', 
    'REFERENCE/S', 
    'AMOUNT DUE', 
    'VAT', 
    'EWT', 
    'AMOUNT PAID', 
    'ACTIONS'
  ]
  const accessorsSalesInvoicePaymentDetail = [
    'referenceNumber', 
    'references', 
    'amountDueBeforePayment', 
    'vat', 
    'ewt', 
    'amountPaid', 
    'actions'
  ]

  const [showPaymentTypeModal, setShowPaymentTypeModal] = useState(false);
  const openPaymentTypeModal = () => {
    setShowPaymentTypeModal(true);
  }
  const closePaymentTypeModal = () => {
    setShowPaymentTypeModal(false);
  }

  const [preReferences, setPreReferences] = useState([]);
  const [showPreReferencesForm, setShowPreReferencesForm] = useState(false);
  const openPreReferencesForm = () => {
    setShowPreReferencesForm(true);
    closePaymentTypeModal();
  }
  const closePreReferencesForm = () => {
    setShowPreReferencesForm(false);
  }

  const addAdvancePayment = () => {
    const newDetail = {
      id: crypto.randomUUID(),
      totalAmount: 0,
      amountPaid: 0,
      amountDueBeforePayment: 0,
      reference: null,
      referenceId: null,
      referenceNumber: "",
      referenceType: "Invoice",
      taxationCodeId: null,
      taxationCode: null,
      vat: 0,
      discounts: 0,
      ewt: 0,
    };

    setSalesInvoicePaymentDetails((prev) => [...prev, newDetail]);

    closePaymentTypeModal();
  }

  useEffect(() => {
    if (preReferences.length > 0) {
      const newDetail = preReferences.map((ref) => {
        let vat = 0;

        if(ref?.vat > 0){
          vat = ((ref?.amountDue ?? 0) * 12) / 112
        }
        return ({
          id: crypto.randomUUID(),
          totalAmount: ref?.amountDue ?? 0,
          amountPaid: ref?.amountDue ?? 0,
          amountDueBeforePayment: ref?.amountDue ?? 0,
          reference: ref ?? null,
          referenceId: ref?.id ?? null,
          referenceNumber: ref?.billNumber ?? "",
          referenceType: "Invoice",
          taxationCodeId: null,
          taxationCode: null,
          vat: vat,
          discounts: ref?.discounts ?? 0,
          ewt: ref?.ewt ?? 0,
        })
      });

      setSalesInvoicePaymentDetails((prev) => {
        const existingIds = new Set(
          prev.map((ref) => ref.referenceId)
        );

        const uniqueDetails = newDetail.filter(
          (ref) => !existingIds.has(ref.referenceId)
        );

        return [...prev, ...uniqueDetails];
      });
      setPreReferences([])
    }
  }, [preReferences, setSalesInvoicePaymentDetails]);

  const insertData = {
    name: "Insert Payment",
    icon: <PostAddIcon fontSize="small" />,
    className: "",
    function: openPaymentTypeModal
  }

  const calculateReferenceEWT = (amountPaid, vat, taxationCode) => {
    const vatableAmount = Number(amountPaid || 0) - Number(vat || 0);
    const ewtRate = Number(taxationCode?.rate || 0) / 100;

    return vatableAmount * ewtRate;
  };

  const handleReferenceAmountChange = (id, field, value) => {
    const amount = value === "" ? "" : Number(value);

    setSalesInvoicePaymentDetails((prev) =>
      prev.map((ref) => {
        if (ref.id !== id) return ref;

        const updatedRef = {
          ...ref,
          [field]: amount,
        };

        if (field === "amountPaid") {
          updatedRef.vat =
            Number(ref?.reference?.vat ?? 0) > 0 && amount !== ""
              ? (amount * 12) / 112
              : 0;
        }

        updatedRef.ewt = calculateReferenceEWT(
          updatedRef.amountPaid,
          updatedRef.vat,
          updatedRef.taxationCode
        );

        return updatedRef;
      })
    );
  };

  const handleReferenceTaxationCodeChange = (id, taxationCode) => {
    setSalesInvoicePaymentDetails((prev) =>
      prev.map((ref) => {
        if (ref.id !== id) return ref;

        const updatedRef = {
          ...ref,
          taxationCode: taxationCode ?? null,
          taxationCodeId: taxationCode?.id ?? null,
        };

        updatedRef.ewt = calculateReferenceEWT(
          updatedRef.amountPaid,
          updatedRef.vat,
          updatedRef.taxationCode
        );

        return updatedRef;
      })
    );
  };

  const [preReference, setPreReference] = useState(null)
  const [showPreReferenceForm, setShowPreReferenceForm] = useState(false)

  const openPreReferenceForm = (_data) => {
    setShowPreReferenceForm(true)
    setSelectedSalesInvoicePaymentDetail(_data)
  }
  const closePreReferenceForm = () => {
    setShowPreReferenceForm(false)
  }

  const [showRemovePreReferenceForm, setShowRemovePreReferenceForm] = useState(false)

  const openRemoveReferenceForm = (_data) => {
    setShowRemovePreReferenceForm(true)
    setSelectedSalesInvoicePaymentDetail(_data)
  }
  const closeRemoveReferenceForm = () => {
    setShowRemovePreReferenceForm(false)
  }

  const handleRemoveReferenceTagging = () => {
    if (!selectedSalesInvoicePaymentDetail) return;

    setSalesInvoicePaymentDetails((prev) =>
      prev.map((ref) =>
        ref.id === selectedSalesInvoicePaymentDetail.id
          ? {
              ...ref,
              reference: null,
              referenceId: null,
              referenceNumber: "",
              totalAmount: 0,
              vat: 0,
            }
          : ref
      )
    );

    setSelectedSalesInvoicePaymentDetail(null);
  };

  useEffect(() => {
    if (preReference && selectedSalesInvoicePaymentDetail) {
      const amountPaid = Number(selectedSalesInvoicePaymentDetail?.amountPaid ?? 0);

      const vat =
        Number(preReference?.vat ?? 0) > 0
          ? (amountPaid * 12) / 112
          : 0;

      const newData = {
        reference: preReference ?? null,
        referenceId: preReference?.id ?? null,
        referenceNumber: preReference?.billNumber ?? "",
        totalAmount: preReference?.totalAmount ?? "",
        vat: vat,
      };

      setSalesInvoicePaymentDetails((prev) =>
        prev.map((ref) =>
          ref.id === selectedSalesInvoicePaymentDetail.id
            ? { ...ref, ...newData }
            : ref
        )
      );

      setPreReference(null);
      setSelectedSalesInvoicePaymentDetail(null);
    }
  }, [preReference, setSalesInvoicePaymentDetails, selectedSalesInvoicePaymentDetail]);

  const actionsSalesInvoicePaymentDetail = [
    isEditState ? { 
      name: "Edit", 
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600",
      function: editHandleSalesInvoicePaymentDetailClick,
      visible: true,
    } : {},
    
    isEditState ? { 
      name: "Delete", 
      tooltip: "delete",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600",
      function: deleteHandleSalesInvoicePaymentDetailClick,
      visible: true,
    } : {},
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleSalesInvoicePaymentDetailClick,
      visible: true,
    },

    
    
    isEditState ? 
    {
      name: "AmountChange",
      function: handleReferenceAmountChange,
      visible: false,
    } : {},

    isEditState ? 
    {
      name: "TaxationCodeChange",
      function: handleReferenceTaxationCodeChange,
      visible: false,
    } : {},

    isEditState ? 
    {
      name: "ReferenceTagging",
      function: openPreReferenceForm,
      visible: false,
    } : {},

    isEditState ? 
    {
      name: "RemoveReferenceTagging",
      function: openRemoveReferenceForm,
      visible: false,
    } : {},
  ];

  useEffect(() => {
    const _amount = salesInvoicePaymentDetails?.reduce((acc, item) => acc + (Number(item.amountPaid) || 0), 0) || 0;
    setTotalSalesInvoiceAmount(_amount)
  }, [salesInvoicePaymentDetails, setAmount])

  const [showSaveReferenceForm, setShowSaveReferenceForm] = useState(false);
  const openSaveReferenceForm = async () => {
    const numPayment = Number(salesInvoicePaymentHeader?.paymentAmount || 0);
    const numTax = Number(salesInvoicePaymentHeader?.withholdingTax || 0);
    
    // Total of user's payment + withholding tax
    const totalApplied = numPayment + numTax;

    const referenceTotalAmount = salesInvoicePaymentDetails?.reduce(
      (sum, i) => sum + (i.amountPaid || 0),
      0
    ) ?? 0;

    if(Math.abs(totalApplied - referenceTotalAmount) > 0.01) {
      setFailMessage("The payment applied does not match the reference total amount.")
      return;
    }
    
    const completeReference = salesInvoicePaymentDetails?.every( (item) => item.referenceId != null ) ?? false;

    if(completeReference) {
      setShowSaveReferenceForm(true);
    } else {
      handleSaveReference(false);
    }
  }
  const closeSaveReferenceForm = () => {
    setShowSaveReferenceForm(false);
  }

  const handleSaveReference = async (_isGenerateEntry) => {
    const _data = {
      headerId: salesInvoicePaymentHeader?.id ?? null,
      salesInvoicePaymentDetails: salesInvoicePaymentDetails,
      isGenerateEntry: _isGenerateEntry
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/SalesInvoicePayment/update-reference`, _data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      setRevertedDetails(salesInvoicePaymentDetails)

      setSuccessMessage("Data updated successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to update data: ${errorMessage}`);
    } finally {
      setLoading(false);
      setIsEditState(false);
    }
  }

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                {isEditState &&
                  <button 
                    type="button"
                    onClick={openAddSalesInvoicePaymentDetailForm} 
                    className="hidden flex items-center gap-2 bg-theme-color text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md active:scale-95"
                  >
                    <AddCircleOutlineIcon fontSize="small" /> 
                    New Reference
                  </button>
                }

                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Sales Invoice Payment Detail"}
                    headers={headersSalesInvoicePaymentDetail}
                    accessors={accessorsSalesInvoicePaymentDetail}
                    data={salesInvoicePaymentDetails}
                    actions={actionsSalesInvoicePaymentDetail}
                    currentPage={currentPageSalesInvoicePaymentDetail}
                    setCurrentPage={setCurrentPageSalesInvoicePaymentDetail}
                    itemsPerPage={10}
                    totalItems={salesInvoicePaymentDetails?.length}
                    hasInsert={isEditState}
                    insertData={insertData}
                  />
                </div>

                {(() => {
                  const currencySymbol = getCurrency?.symbol || "";
                  const numPayment = Number(salesInvoicePaymentHeader?.paymentAmount || 0);
                  const numTax = Number(salesInvoicePaymentHeader?.withholdingTax || 0);
                  
                  // Total of user's payment + withholding tax
                  const totalApplied = numPayment + numTax;

                  const referenceTotalAmount = salesInvoicePaymentDetails?.reduce(
                    (sum, i) => sum + (i.amountPaid || 0),
                    0
                  ) ?? 0;

                  return (
                    <div className="md:col-span-2">
                      <div className="relative overflow-hidden bg-white border border-gray-200/80 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-200">
                        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                          
                          {/* Left Side: Total Applied */}
                          <div className="w-full lg:w-auto p-4 rounded-xl bg-gray-50/80 border border-gray-200/70 flex flex-col gap-2.5 min-w-[280px]">
                            
                            {/* Input Line Items */}
                            <div className="space-y-1.5 text-xs">
                              <div className="flex justify-between items-center text-gray-500">
                                <span>Payment Amount</span>
                                <span className="font-semibold text-gray-800 tabular-nums">
                                  {currencySymbol} {FormatValueToDecimal(numPayment)}
                                </span>
                              </div>

                              <div className="flex justify-between items-center text-gray-500">
                                <span>Withholding Tax</span>
                                <span className="font-semibold text-gray-800 tabular-nums">
                                  + {currencySymbol} {FormatValueToDecimal(numTax)}
                                </span>
                              </div>
                            </div>

                            {/* Total Applied */}
                            <div className="border-t border-gray-200/80 pt-2 flex justify-between items-baseline">
                              <span className="text-xs font-bold uppercase tracking-wider text-gray-700">
                                Payment Applied
                              </span>
                              <span className="text-lg font-extrabold text-theme-color tabular-nums">
                                {currencySymbol} {FormatValueToDecimal(totalApplied)}
                              </span>
                            </div>

                          </div>

                          {/* Right Side: Tally Status */}
                          <div className="flex items-start w-full lg:w-auto lg:min-w-[280px]">
                            {Math.abs(totalApplied - referenceTotalAmount) > 0.01 ? (
                              <div className="w-full rounded-xl border border-amber-200 bg-amber-50 p-4">
                                <div className="flex items-start gap-3">
                                  <div className="rounded-full bg-amber-100 p-2">
                                    <ErrorIcon className="text-amber-600" />
                                  </div>

                                  <div>
                                    <p className="text-sm font-bold text-amber-800">
                                      Payment Not Tallying
                                    </p>
                                    <p className="mt-1 text-xs text-amber-700">
                                      The payment applied does not match the reference total amount.
                                    </p>

                                    <div className="mt-3 space-y-1 text-xs">
                                      <div className="flex justify-between gap-4">
                                        <span>Payment Applied</span>
                                        <span className="font-semibold tabular-nums">
                                          {currencySymbol} {FormatValueToDecimal(totalApplied)}
                                        </span>
                                      </div>

                                      <div className="flex justify-between gap-4">
                                        <span>Reference Total</span>
                                        <span className="font-semibold tabular-nums">
                                          {currencySymbol} {FormatValueToDecimal(referenceTotalAmount)}
                                        </span>
                                      </div>

                                      <div className="flex justify-between gap-4 border-t border-amber-200 pt-2 font-bold">
                                        <span>Difference</span>
                                        <span className="tabular-nums">
                                          {currencySymbol}{" "}
                                          {FormatValueToDecimal(totalApplied - referenceTotalAmount)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="w-full rounded-xl border border-green-200 bg-green-50 p-4">
                                <div className="flex items-start gap-3">
                                  <div className="rounded-full bg-green-100 p-2">
                                    <CheckCircleIcon className="text-green-600" />
                                  </div>

                                  <div>
                                    <p className="text-sm font-bold text-green-800">
                                      Payment Tallying
                                    </p>
                                    <p className="mt-1 text-xs text-green-700">
                                      The payment applied matches the reference total amount.
                                    </p>

                                    <div className="mt-3 border-t border-green-200 pt-2">
                                      <p className="text-xs text-green-700">
                                        Reference Total Amount
                                      </p>
                                      <p className="mt-1 text-lg font-extrabold text-green-800 tabular-nums">
                                        {currencySymbol} {FormatValueToDecimal(referenceTotalAmount)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                        </div>
                      </div>
                    </div>
                  );
                })()}

                <div className="md:col-span-2 hidden">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                    
                    {/* Left Side: Details Breakdown */}
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Transaction Summary
                          </p>
                          <p className="text-xs text-gray-500">Breakdown of all line items</p>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Final Total & Status */}
                    <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                      <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                        Final Amount Received
                      </p>
                      <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                        <span className="text-4xl font-black text-gray-900 tracking-tight">
                          {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalSalesInvoiceAmount)}`}
                        </span>
                      </div>

                      {/* Visual indicator of validation */}
                      {amount > 0 ? (
                        <span className="inline-flex items-center text-[10px] font-bold text-green-600 bg-green-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-green-100">
                          <span className="mr-1">●</span> Ready to Save
                        </span>
                      ) : (
                        <span className="inline-flex items-center text-[10px] font-bold text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full uppercase tracking-tight border border-amber-100">
                          <span className="mr-1">○</span> No amount detected
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              {!isEditState ?
              <>
                <button
                  onClick={closeModal}
                  className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
                >
                  Cancel
                </button>
                { (salesInvoicePaymentHeader.status === "Posted" || salesInvoicePaymentHeader.status === "Pending") && <button
                  onClick={onEditState}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Edit Reference
                </button>}
              </>
              :
              <>
                <button
                  onClick={offEditState}
                  className="px-10 py-2.5 rounded-lg bg-red-500 text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Cancel Edit
                </button>
                <button
                  onClick={openSaveReferenceForm}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Reference
                </button>
              </>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AddUpdateReferenceModal 
        visible={showViewSalesInvoicePaymentDetailForm} 
        onClose={closeViewSalesInvoicePaymentDetailForm}
        modalName={"View Reference"}
        parentModalName={modalName}
        data={selectedSalesInvoicePaymentDetail}
        salesInvoicePaymentHeader={salesInvoicePaymentHeader}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer}
        isEditable={false}
      />

      <AddUpdateReferenceModal 
        visible={showAddSalesInvoicePaymentDetailForm} 
        onClose={closeAddSalesInvoicePaymentDetailForm}
        modalName={"Add Reference"}
        parentModalName={modalName}
        data={selectedSalesInvoicePaymentDetail}
        salesInvoicePaymentHeader={salesInvoicePaymentHeader}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer}
        isEditable={true}
      />

      <AddUpdateReferenceModal 
        visible={showUpdateSalesInvoicePaymentDetailForm} 
        onClose={closeUpdateSalesInvoicePaymentDetailForm}
        modalName={"Update Reference"}
        parentModalName={modalName}
        data={selectedSalesInvoicePaymentDetail}
        salesInvoicePaymentHeader={salesInvoicePaymentHeader}
        salesInvoicePaymentDetails={salesInvoicePaymentDetails} setSalesInvoicePaymentDetails={setSalesInvoicePaymentDetails}
        customer={customer}
        isEditable={true}
        isReferenceTagging={false}
      />

      <ConfirmationModal 
        visible={showDeleteSalesInvoicePaymentDetailForm} 
        onClose={closeDeleteSalesInvoicePaymentDetailForm} 
        onSave={handleDeleteSalesInvoicePaymentDetail} 
        modalName={"Delete"} 
        message={`Do you want to remove this?.`}
      />

      <ConfirmationModal 
        visible={showSaveReferenceForm} 
        onClose={closeSaveReferenceForm} 
        onSave={()=>handleSaveReference(true)} 
        modalName={"Final Tagging"} 
        message={`This will generate "Return Entry", are you sure you want to proceed?.`}
      />

      

      <PaymentTypeModal
        isOpen={showPaymentTypeModal}
        onClose={closePaymentTypeModal}
        onAdvancePayment={addAdvancePayment}
        onChooseReferences={openPreReferencesForm}
      />

      <SalesPerCustomerSelect 
        visible={showPreReferenceForm} 
        onClose={closePreReferenceForm}
        modalName={"Select Reference"}
        data={preReference} setData={setPreReference}
        customer={customer}
      />

      <ConfirmationModal 
        visible={showRemovePreReferenceForm} 
        onClose={closeRemoveReferenceForm} 
        onSave={handleRemoveReferenceTagging} 
        modalName={"Delete"} 
        message={`Do you want to remove this tagging?.`}
      />

      <SalesPerCustomerMultipleSelect 
        visible={showPreReferencesForm} 
        onClose={closePreReferencesForm}
        modalName={"Select References"}
        data={preReferences} setData={setPreReferences}
        customer={customer}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
//#endregion














//#region Chart of Accounts
const AddUpdateChartOfAccountsModal = ({
  visible, onClose, onSave, modalName, parentModalName,
  data,
  isEditable,
  chartOfAccounts, setChartOfAccounts,
  salesInvoicePaymentDetails, setSalesInvoicePaymentDetails,
  customer
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");

  const [failMessage, setFailMessage] = useState("");
  const [glAccount, setGLAccount] = useState(null);
  const [debitCredit, setDebitCredit] = useState("Debit");
  const [amount, setAmount] = useState(0);
  const [totalSalesInvoiceAmount, setTotalSalesInvoiceAmount] = useState(0);


  const [showGLAccountSelectForm, setShowGLAccountSelectForm] = useState(false);
  const openGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(true);
  }
  const closeGLAccountSelectForm = () => {
    setShowGLAccountSelectForm(false);
  }

  const handleSubmit = async () => {
    // Logic updated to match your state requirements
    if (!glAccount || !debitCredit ) {
      setFailMessage("Please fill up all required fields.");
      return;
    }

    if(modalName === "Add Account"){
      const foundData = chartOfAccounts.find(i => i.glAccountId === glAccount.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        glAccountId: glAccount?.id,
        glAccount: glAccount,
        glAccountName: glAccount?.accountName,
        debitCredit: debitCredit,
        amount: Number(amount),
      }

      setChartOfAccounts((prev) => [...prev, newData])
    }

    if(modalName === "Update Account"){
      const foundData = chartOfAccounts.find(i => i.glAccountId === glAccount.id && data?.glAccountId !== glAccount.id)

      if (foundData) {
        setFailMessage("Already added this account.");
        return;
      }

      const newData = {
        glAccountId: glAccount?.id,
        glAccount: glAccount,
        glAccountName: glAccount?.accountName,
        debitCredit: debitCredit,
        amount: Number(amount),
      }

      setChartOfAccounts(prev =>
        prev.map(item =>
          item.glAccountId === data?.glAccountId
            ? newData
            : item
        )
      );
    }

    closeModal();
  };

  const resetLocalVariables = () => {
    setGLAccount(null)
    setDebitCredit("Debit")
    setAmount(0)
  }

  const closeModal = () => {
    setFailMessage("");
    onClose();
    resetLocalVariables();
  };

  useEffect(() => {
    if(visible && data){
      setGLAccount(data?.glAccount)
      setDebitCredit(data?.debitCredit)
      setAmount(data?.amount)
    }
  }, [visible, data])

  useEffect(() => {
    const _amount = salesInvoicePaymentDetails?.reduce((acc, item) => acc + (Number(item.amountPaid) || 0), 0) || 0;
    setTotalSalesInvoiceAmount(_amount)
  }, [salesInvoicePaymentDetails, setTotalSalesInvoiceAmount])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Enter the transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <>
                  {/* --- Section 1: Entities --- */}
                  <div className="space-y-4 md:col-span-2 mt-2">
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 border-b pb-1">Basic Details</h3>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-gray-400 pb-1">{`To Receive: ${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalSalesInvoiceAmount)}`}</h3>
                  </div>
                  {isEditable ?
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Account <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={glAccount?.accountName || ""}
                          readOnly
                        />
                        {!glAccount ?
                          <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openGLAccountSelectForm}>
                            <ManageSearchIcon className="text-white"/>
                          </button> 
                          :
                          <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setGLAccount(null)}>
                            <RemoveCircleIcon className="text-white"/>
                          </button>
                        }
                      </div>
                    </div>
                    :
                    <div>
                      <label className="block text-sm font-semibold mb-1 text-gray-700">
                        Account <span className="text-red-500">*</span>
                      </label>
                      <div className="flex flex-row items-center">
                        <input
                          type="text"
                          placeholder="Select Account"
                          className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                          value={glAccount?.accountName || ""}
                          readOnly
                        />
                      </div>
                    </div>
                  }

                  <div>
                    <label className="block text-sm font-medium mb-1 text-gray-700 ">
                      Debit / Credit <span className="text-red-500">*</span>
                    </label>
                    <DebitCreditSelect data={debitCredit} setData={setDebitCredit} isEditable={isEditable}/>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1 text-gray-700">
                      Amount <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-row items-center">
                      <input
                        type="number"
                        className="w-full border border-gray-300 text-sm rounded-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        readOnly={!isEditable}
                      />
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <span className="font-semibold text-gray-400 italic">
                        {getCurrency?.symbol ?? ""}
                        {FormatValueToDecimal(amount || 0)}
                      </span>
                    </div>
                  </div>
                </>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Save Transaction
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <ChartOfAccountsSelect
        visible={showGLAccountSelectForm}
        onClose={closeGLAccountSelectForm}
        modalName={"Select Account"}
        data={glAccount} // full current data array
        setData={setGLAccount}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
const ViewChartOfAccountsModal = ({
  visible, onClose, onSave, modalName,
  chartOfAccounts, setChartOfAccounts,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  // const [amount, setAmount] = useState(0);
  const [totalDebitChartOfAccountAmount, setTotalDebitChartOfAccountAmount] = useState(0);
  const [totalCreditChartOfAccountAmount, setTotalCreditChartOfAccountAmount] = useState(0);

  const closeModal = () => {
    onClose();
  };

  const [selectedChartOfAccount, setSelectedChartOfAccount] = useState(null);
  const [currentPageChartOfAccount, setCurrentPageChartOfAccount] = useState(1);

  const headersChartOfAccount = [
    'ACCOUNT', 
    'DEBIT', 
    'CREDIT', 
    'ACTIONS'
  ]
  const accessorsChartOfAccount = [
    'glAccountName', 
    'debit', 
    'credit', 
    'actions'
  ]

  const [showViewChartOfAccountForm, setShowViewChartOfAccountForm] = useState(false);
  const openViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(true);
  }
  const closeViewChartOfAccountForm = () => {
    setShowViewChartOfAccountForm(false);
    setSelectedChartOfAccount(null)
  }

  const viewHandleChartOfAccountClick = (_data) => {
    setSelectedChartOfAccount(_data)
    openViewChartOfAccountForm();
  }

  const actionsChartOfAccount = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleChartOfAccountClick,
      visible: true,
    },
  ];

  useEffect(() => {
    const _amount = chartOfAccounts?.filter(i => i.debitCredit === "Debit").reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    setTotalDebitChartOfAccountAmount(_amount)
  }, [chartOfAccounts, setTotalDebitChartOfAccountAmount])

  useEffect(() => {
    const _amount = chartOfAccounts?.filter(i => i.debitCredit === "Credit").reduce((acc, item) => acc + (Number(item.amount) || 0), 0) || 0;
    setTotalCreditChartOfAccountAmount(_amount)
  }, [chartOfAccounts, setTotalCreditChartOfAccountAmount])

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
                <p className="text-sm text-gray-500">Transaction details below</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="py-5 space-y-5">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                  <CreateTable
                    tableName={"Chart Of Accounts Transaction"}
                    headers={headersChartOfAccount}
                    accessors={accessorsChartOfAccount}
                    data={chartOfAccounts}
                    actions={actionsChartOfAccount}
                    currentPage={currentPageChartOfAccount}
                    setCurrentPage={setCurrentPageChartOfAccount}
                    itemsPerPage={10}
                    totalItems={chartOfAccounts?.length}
                  />
                </div>

                <div className="md:col-span-2">
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                    
                    {/* Left Side: Details Breakdown */}
                    <div className="flex gap-4 w-full lg:w-auto">
                      <div className="bg-theme-color/10 p-3 rounded-xl h-fit">
                        <AccountBalanceWalletIcon className="text-theme-color" />
                      </div>
                      
                      <div className="flex-1 space-y-3">
                        <div>
                          <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
                            Accounts Summary
                          </p>
                          <p className="text-xs text-gray-500">Breakdown of all accounts</p>
                          <span className="text-[16px] font-bold uppercase tracking-widest text-gray-400">
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Right Side: Final Total & Status */}
                    <div className="bg-white rounded-2xl flex flex-col justify-between items-start lg:items-center gap-2">
                      <div className="bg-white flex flex-col lg:flex-row justify-between items-start lg:items-center gap-10">
                        <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                          <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                            DEBIT AMOUNT
                          </p>
                          <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                            <span className="text-4xl font-black text-gray-900 tracking-tight">
                              {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalDebitChartOfAccountAmount)}`}
                            </span>
                          </div>
                        </div>

                        <div className="w-full lg:w-auto text-left lg:text-right border-t lg:border-t-0 pt-4 lg:pt-0 border-gray-100">
                          <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
                            CREDIT AMOUNT
                          </p>
                          <div className="flex items-baseline justify-start lg:justify-end gap-2 mb-2">
                            <span className="text-4xl font-black text-gray-900 tracking-tight">
                              {`${getCurrency?.symbol || ""} ${FormatValueToDecimal(totalCreditChartOfAccountAmount)}`}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <AddUpdateChartOfAccountsModal 
        visible={showViewChartOfAccountForm} 
        onClose={closeViewChartOfAccountForm}
        modalName={"View Account"}
        parentModalName={modalName}
        data={selectedChartOfAccount}
        chartOfAccounts={chartOfAccounts} setChartOfAccounts={setChartOfAccounts}
        // customer={customer}
        isEditable={false}
      />
    </>
  );
};
//#endregion













//#region Journal
const CreateJournalModal = ({
  visible, onClose, onSave, modalName,
  data, fetchData,
  isEditable,
}) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false)
  const [journalLines, setJournalLines] = useState([])
  const [documentNumber, setDocumentNumber] = useState("") 
  const [vendor, setVendor] = useState(null) 
  const [customer, setCustomer] = useState(null)
  const [documentType, setDocumentType] = useState(null)
  const [documentDate, setDocumentDate] = useState(null)
  const today = new Date().toISOString().split("T")[0];
  const [postingDate, setPostingDate] = useState(today)
  const [fiscalYear, setFiscalYear] = useState("")
  const [fiscalPeriod, setFiscalPeriod] = useState("")
  const [currency, setCurrency] = useState("PHP")
  const [referenceNumber, setReferenceNumber] = useState("")
  const [documentHeaderText, setDocumentHeaderText] = useState("")

  const accountData = JSON.parse(localStorage.getItem("accountData"));

  const generateNumber = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/Journal/generate-number` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, []);
  
  const generateJournalLines = useCallback(async () => {
    const _data = {
      description: data?.paymentNumber ?? "",
      key: "paymentReceived",
      type: "Receivables",
      debitCredit: "Debit",
      mainAccountId: data?.depositToAccountId ?? null,
      journalLines: data?.salesInvoicePaymentDetails?.map(item => {
        return {
          glAccountId: item?.accountId ?? null,
          referenceNumber: item?.salesInvoiceNumber ?? null,
          amount: item?.amountPaid ?? null,
        }}),
      amount: data?.amount ?? 0,
    }
    try {
      const response = await axios.post(`${apiUrl}/api/Journal/auto-journal-line` , _data, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, [data]);

  const fetchNumber = useCallback(async () => {
    setLoading(true)

    const _number = await generateNumber();
    setDocumentNumber(_number?.number)

    const _journalLines = await generateJournalLines();
    setJournalLines(_journalLines)

    setLoading(false)
  }, [generateNumber, generateJournalLines])

  useEffect(() => {
    if (visible && !documentNumber) {
      fetchNumber()
      setCustomer(data?.customer ?? null)
      setCustomer(data?.customer ?? null)

      const _documentType = {
        id: 2,
        description: "Accounts Receivable",
        isActive: true
      }

      setDocumentType(_documentType)
      setDocumentDate(data?.documentDate)
      setReferenceNumber(data?.documentNumber)
    }
  }, [visible, documentNumber, fetchNumber, data])

  const handleAddData = async () => {
    const data = {
      journalLines: journalLines,
      vendorId: vendor?.vendorId,
      customerId: customer?.customerId,
      documentSubType: "Receive",
      documentNumber: documentNumber,
      documentTypeId: documentType?.id,
      documentDate: documentDate,
      postingDate: postingDate,
      fiscalYear: fiscalYear,
      fiscalPeriod: fiscalPeriod,
      currency: currency,
      referenceNumber: referenceNumber,
      documentHeaderText: documentHeaderText,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Journal`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 

  const handleSubmit = async () => {
    if(!documentNumber
      || !documentType
      || !postingDate
      || !currency
      || journalLines.length <= 0
    ){
      setFailMessage("Please fill up all required fields.")
      return;
    }

    await handleAddData();
    closeModal();
  };

  const resetLocalVariables = () => {
    setJournalLines([])
    setDocumentNumber("")
    setVendor(null)
    setCustomer(null)
    setDocumentType(null)
    setDocumentDate(null)
    setPostingDate(today)
    setFiscalYear("")
    setFiscalPeriod("")
    setCurrency("PHP")
    setReferenceNumber("")
    setDocumentHeaderText("")
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{`${modalName}`}</h2>
                <p className="text-sm text-gray-500">{`Document Number: ${documentNumber}`}</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <JournalHeader 
                type={"AR"}
                isEditable={true}
                documentNumber={documentNumber} setDocumentNumber={setDocumentNumber}
                journalLines={journalLines} setJournalLines={setJournalLines}
                vendor={vendor} setVendor={setVendor}
                customer={customer} setCustomer={setCustomer}
                documentType={documentType} setDocumentType={setDocumentType}
                documentDate={documentDate} setDocumentDate={setDocumentDate}
                postingDate={postingDate} setPostingDate={setPostingDate}
                fiscalYear={fiscalYear} setFiscalYear={setFiscalYear}
                fiscalPeriod={fiscalPeriod} setFiscalPeriod={setFiscalPeriod}
                currency={currency} setCurrency={setCurrency}
                referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                documentHeaderText={documentHeaderText} setDocumentHeaderText={setDocumentHeaderText}
                documentData={data}
              />
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Create Journal
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
//#endregion
















//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  customerFilter, setCustomerFilter,
  statusFilter, setStatusFilter,
  paymentDateFilter, setPaymentDateFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_customerFilter, _setCustomerFilter] = useState(customerFilter);
  const [_statusFilter, _setStatusFilter] = useState(statusFilter);
  const [_paymentDateFilter, _setPaymentDateFilter] = useState(paymentDateFilter);

  useEffect(() => {
    if(visible){
      _setCustomerFilter(customerFilter)
      _setStatusFilter(statusFilter)
      _setPaymentDateFilter(paymentDateFilter)
    }
  }, [visible, customerFilter, statusFilter, paymentDateFilter])

  const handleSubmit = async () => {
    setCustomerFilter(_customerFilter);
    setStatusFilter(_statusFilter);
    setPaymentDateFilter(_paymentDateFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            // initial={{ opacity: 0 }}
            // animate={{ opacity: 1 }}
            // exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Customer <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Customer"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_customerFilter ? `${_customerFilter?.customerId} - ${_customerFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_customerFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setCustomerFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Status
                  </label>
                  <PaymentStatusSelectWithAll data={_statusFilter} setData={_setStatusFilter} isEditable={true}/>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Payment Date
                  </label>
                  <DateSelect data={_paymentDateFilter} setData={_setPaymentDateFilter} isEditable={true}/>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={_customerFilter} setData={_setCustomerFilter}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion